/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-did-update-set-state */
import React, { Component, ReactNode } from "react";
import { MsalContext, withMsal } from "@azure/msal-react";
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Icon,
  Select,
  Checkbox,
  Modal,
  Collapse,
  message,
  Radio,
  Tag,
  Switch,
} from "antd";
import moment from "moment";
import { RouteComponentProps } from "react-router-dom";
import IBAN from "iban";
import { isNumeric } from "../../../utils";
import DuplicateBusinessPartners from "./DuplicateBusinessPartners";
import City from "./City";
import PostalCode from "./PostalCode";
import RejectBusinessPartner from "./RejectBP";
import {
  CountryType,
  BusinessPartnerOptionType,
  CurrencyRefType,
  TargetSystemType,
  PostalCodeType,
  CityType,
  BusinessPartnerType,
  LanguageType,
  CityPayloadType,
  BusinessPartnerPayLoadType,
  PostalCodePayloadType,
  StateProviceType,
  BankType,
  BankAccountNumberType,
  StatusType,
  DuplicateBPCheckPayloadType,
  BpActionType,
  PseudoRoletype,
  BicSwiftType,
  BankBranchType,
} from "../types";

import { UserInfoType } from "../../App/types";
import "../businesspartnerdetails.scss";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";
import { T } from "antd/lib/upload/utils";

const { Option } = Select;
const { Panel } = Collapse;

const euTaxErrMessage = "Either Vies Number or Local Tax/Fiscal ID is required";
const nonEUTaxErrMessage = "One of the tax Number is required";
const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};
// const formPopUpLayout = {
//   labelCol: {
//     xs: { span: 24 },
//     sm: { span: 8 },
//   },
//   wrapperCol: {
//     xs: { span: 24 },
//     sm: { span: 16 },
//   },
// };

// const { TextArea } = Input;
interface ExtraType {
  data: any;
}
interface BusinessPartnerProps extends RouteComponentProps<any> {
  bpTypes: BusinessPartnerOptionType[] | null;
  countries: CountryType[] | null;
  currencyRefs: CurrencyRefType[] | null;
  targetSystems: TargetSystemType[] | null;
  cities: CityType[] | null;
  postalCodes: PostalCodeType[] | null;
  duplicateBPs: BusinessPartnerType[] | null;
  languages: LanguageType[] | null;
  cityCreated: number | null;
  poBoxCityCreated: number | null;
  bpCreated: boolean;
  bpUpdated: boolean;
  selectedBP: BusinessPartnerType | null;
  stateProvinces: StateProviceType[] | null;
  postalCodeCreated: number | null;
  bankAccountNumbers: BankAccountNumberType[] | null;
  cityUpdated: boolean;
  poBoxCityUpdated: boolean;
  postalCodeUpdated: boolean;
  banks: BankType[] | null;
  statuses: StatusType[] | null;
  bpRejected: boolean;
  userInfo: UserInfoType;
  deleteBPSucceeded: boolean;
  bpActivated: boolean;
  duplicateBPPagination: PaginationInfoType;
  bpActions: BpActionType[];
  pseudoRoleMap: PseudoRoletype[];
  bicSwifts: BicSwiftType[] | null;
  bankBranch: BankBranchType | null;
  poBoxPostalCodeCreated: number | null;
  poBoxPostalCodeUpdated: number | null;
  msalContent: any;
  fetchLookUp: () => any;
  retainUpdatedBusinessParter: (businessPartnerID: number) => any;
  fetchCitiesAndPostalCodesByCountry: (countryID: number) => any;
  checkDubplicateOf: (payload: DuplicateBPCheckPayloadType) => any;
  resetDuplicateBPs: () => any;
  createCity: (payload: CityPayloadType) => any;
  updateCity: (cityID: number, payload: CityPayloadType) => any;
  resetCityCreatedFlag: () => any;
  createBusinessPartner: (payload: BusinessPartnerPayLoadType) => any;
  updateBusinessPartner: (payload: BusinessPartnerPayLoadType) => any;
  setSelectedBP: (selectedBP: BusinessPartnerType) => any;
  resetBPCreatedFlag: () => any;
  resetBPUpdatedFlag: () => any;
  createPostalCode: (payload: PostalCodePayloadType) => any;
  resetPostalCodeCreatedFlag: () => any;
  updatePostalCode: (
    postalCodeID: number,
    payload: PostalCodePayloadType
  ) => any;
  resetCityUpdatedFlag: () => any;
  resetPostalCodeUpdatedFlag: () => any;
  setMenuKey: (key: string) => any;
  resetSelectedBP: () => any;
  deleteBusinessPartner: (businessPartnerID: number) => any;
  resetDeleteBPSucceeded: () => any;
  flushCountryDependentLookupData: () => any;
  fetchBicSwifts: (bankCountryCode: string) => any;
  resetBicSwifts: () => any;
  fetchBankBranch: (bicSwiftCode: string) => any;
  resetBankBranch: () => any;
}

interface RoleType extends BusinessPartnerOptionType {
  checked: boolean;
}
interface BusinessPartnerStates {
  duplicateCheckInProgress: boolean;
  bpId: number | null;
  mode: string;
  cityModalVisibility: boolean;
  poBoxCityModalVisibility: boolean;
  postalCodeModalVisibility: boolean;
  poBoxPostalCodeModalVisibility: boolean;
  businessPartnerNameOne: string;
  businessPartnerNameOneError: boolean;
  businessPartnerNameTwo: string;
  businessPartnerNameTwoError: boolean;
  searchName: string;
  website: string;
  websiteError: boolean;
  telephoneAreaCodeError: boolean;
  telephoneNumber: string | null;
  telephoneNumberError: boolean;
  email: string;
  emailError: boolean;
  streetOne: string;
  streetOneError: boolean;
  countryReference: number;
  countryReferenceError: boolean;
  sepaCountry: boolean;
  currencyReferrence: number;
  currencyReferrenceError: boolean;
  poBoxZipCode: number | null;
  poBoxZipCodeError: boolean;
  dunsNumber: string;
  postOfficeBox: string;
  poBoxCity: number;
  taxNumber: string;
  houseNumber: string;
  stateProvinceReference: number | null;
  stateProvinceReferenceError: boolean;
  bank: string | null;
  bankError: boolean;
  bicSwift: string;
  bicSwiftError: boolean;
  bankAccountNumber: string;
  bankAccountNumberError: boolean;
  bankIBANError: boolean;
  yearlyTurnover: number | null;
  yearlyTurnoverError: boolean;
  chamberOfCommerce: string;
  city: number | null;
  postalCode: number | null;
  cityError: boolean;
  postalCodeError: boolean;
  duplicateBPModalVisibility: boolean;
  activePanels: string[];
  roles?: RoleType[] | null;
  selectedRole: number | null;
  selectedRoleError: boolean;
  rejectBPModalVisibility: boolean;
  taxNumberError: boolean;
  modifyRoleManually: boolean;
  externalSystemReferenceIDs: any;
  externalSystems: any;
  bankCountry: number | null;
  bankCountryError: boolean;
  [x: string]: any;
  paymentTerms: string;
  paymentTermsError: boolean;
  nationalVATNumber: string;
  relevantPlants: string;
  relevantPlantsError: boolean;
  comments: string;
  isIBAN: boolean;
  poBoxCountryReference: number;
  poBoxStateProvinceReference: number;
  poBoxStateProvinceReferenceError: boolean;
  viesCountry: number;
  viesCountryError: boolean;
  intTaxCountry: number;
  intTaxCountryError: boolean;
  localTaxCountry: number;
  localTaxCountryError: boolean;
  isEUCountry: boolean;
  intTaxNumber: string;
  intTaxNumberError: boolean;
  euTaxError: boolean;
  nonEUTaxError: boolean;
  viesCountryCode: string;
}

const initialState = {
  duplicateCheckInProgress: false,
  bpId: null,
  mode: "create",
  cityModalVisibility: false,
  poBoxCityModalVisibility: false,
  postalCodeModalVisibility: false,
  poBoxPostalCodeModalVisibility: false,
  businessPartnerNameOne: "",
  businessPartnerNameOneError: false,
  businessPartnerNameTwo: "",
  businessPartnerNameTwoError: false,
  searchName: "",
  website: "",
  telephoneNumber: "",
  telephoneNumberError: false,
  email: "",
  emailError: false,
  streetOne: "",
  streetOneError: false,
  countryReference: null,
  countryReferenceError: false,
  sepaCountry: false,
  currencyReferrence: null,
  currencyReferrenceError: false,
  poBoxZipCode: null,
  poBoxZipCodeError: false,
  dunsNumber: "",
  houseNumber: "",
  postOfficeBox: "",
  poBoxCity: null,
  stateProvinceReference: null,
  stateProvinceReferenceError: false,
  taxNumber: "",
  taxNumberError: false,
  bank: undefined,
  bicSwift: "",
  bankError: false,
  bankAccountNumber: "",
  bankAccountNumberError: false,
  bankIBANError: false,
  yearlyTurnover: null,
  yearlyTurnoverError: false,
  chamberOfCommerce: "",
  city: null,
  cityError: false,
  postalCode: null,
  postalCodeError: false,
  duplicateBPModalVisibility: false,
  activePanels: [],
  roles: null,
  selectedRole: null,
  selectedRoleError: false,
  rejectBPModalVisibility: false,
  modifyRoleManually: false,
  externalSystemReferenceIDs: null,
  bankCountry: null,
  bankCountryError: false,
  websiteError: false,
  telephoneAreaCodeError: false,
  bicSwiftError: false,
  nationalVATNumber: "",
  paymentTerms: "",
  paymentTermsError: false,
  relevantPlants: "",
  relevantPlantsError: false,
  comments: "",
  isIBAN: true,
  poBoxCountryReference: null,
  poBoxStateProvinceReference: null,
  poBoxStateProvinceReferenceError: false,
  viesCountry: null,
  viesCountryError: false,
  intTaxCountry: null,
  intTaxCountryError: false,
  localTaxCountry: null,
  localTaxCountryError: false,
  isEUCountry: false,
  intTaxNumber: "",
  intTaxNumberError: false,
  euTaxError: false,
  nonEUTaxError: false,
  viesCountryCode: "",
};

class BusinessPartnerDetails extends Component<
  BusinessPartnerProps,
  BusinessPartnerStates
> {
  static contextType = MsalContext;
  constructor(props: BusinessPartnerProps) {
    super(props);

    // const { bpTypes } = props;
    // const BProles = bpTypes
      // ? bpTypes.map((item) => ({ ...item, checked: true }))
      // : null;
    // roles,

    this.state = {
      ...initialState,
    };
  }

  componentDidMount() {
    const {
      location,
      setMenuKey,
      fetchLookUp,
      resetBankBranch,
      retainUpdatedBusinessParter,
      countries,
    } = this.props;
    const menuKey = location.pathname.replace(/\//gi, "").replace(/-/gi, " ");
    setMenuKey(menuKey);

    fetchLookUp();
    if (countries) {
      const { match } = this.props;
      if (match.params.bpID) {
        const { bpID } = match.params;
        retainUpdatedBusinessParter(bpID);
      }
    }
    resetBankBranch();
  }

  componentDidUpdate(
    prevProps: BusinessPartnerProps,
    prevState: BusinessPartnerStates
  ) {
    const { match, bpTypes, resetSelectedBP } = this.props;

    if (match.params.bpID !== prevProps.match.params.bpID) {
      const roles = bpTypes.map((item) => ({ ...item, checked: true }));
      this.setState({ ...initialState, roles });
      if (match.params.bpID === undefined) {
        resetSelectedBP();
      }
    }

    if (bpTypes && prevProps.bpTypes === null) {
      const roles = bpTypes.map((item) => ({ ...item, checked: true }));
      this.setState({ roles });
    }

    const { duplicateBPs } = this.props;
    if (
      duplicateBPs &&
      duplicateBPs.length > 0 &&
      prevProps.duplicateBPs === null
    ) {
      this.setState({
        duplicateBPModalVisibility: true,
        duplicateCheckInProgress: false,
      });
    }

    const {
      cityCreated,
      cities,
      stateProvinces,
      resetCityCreatedFlag,
    } = this.props;
    if (cityCreated !== null && prevProps.cityCreated === null) {
      this.setState({
        cityModalVisibility: false,
        city: cityCreated,
        cityError: false,
      });

      // update state province
      const city = cities.find((item) => item.ciId === cityCreated);
      const newStateProvince = stateProvinces.find(
        (item) => item.spId === city.ciStateProvinceRef
      );
      if (newStateProvince && newStateProvince.spId) {
        this.setState({
          stateProvinceReference: newStateProvince.spId,
          stateProvinceReferenceError: false,
        });
      } else {
        this.setState({
          stateProvinceReference: null,
          stateProvinceReferenceError: false,
        });
      }
      message.success("A new city is created.");
      resetCityCreatedFlag();
    }
    const { poBoxCityCreated } = this.props;
    if (poBoxCityCreated !== null && prevProps.poBoxCityCreated === null) {
      this.setState({
        poBoxCityModalVisibility: false,
        poBoxCity: poBoxCityCreated,
        poBoxCityError: false,
      });

      // update pobox state province
      const poBoxCity = cities.find((item) => item.ciId === poBoxCityCreated);
      const newPoBoxStateProvince = stateProvinces.find(
        (item) => item.spId === poBoxCity.ciStateProvinceRef
      );
      if (newPoBoxStateProvince && newPoBoxStateProvince.spId) {
        this.setState({
          poBoxStateProvinceReference: newPoBoxStateProvince.spId,
          poBoxStateProvinceReferenceError: false,
        });
      } else {
        this.setState({
          poBoxStateProvinceReference: null,
          poBoxStateProvinceReferenceError: false,
        });
      }
      message.success("A new city is created.");
      resetCityCreatedFlag();
    }

    const { cityUpdated, resetCityUpdatedFlag } = this.props;
    if (cityUpdated && !prevProps.cityUpdated) {
      this.setState({
        cityModalVisibility: false,
      });
      // update state province
      const city = cities.find((item) => item.ciId === this.state.city);
      const newStateProvince = stateProvinces.find(
        (item) => item.spId === city.ciStateProvinceRef
      );
      if (newStateProvince && newStateProvince.spId) {
        this.setState({
          stateProvinceReference: newStateProvince.spId,
          stateProvinceReferenceError: false,
        });
      } else {
        this.setState({
          stateProvinceReference: null,
          stateProvinceReferenceError: false,
        });
      }
      message.success("A City name is updated.");
      resetCityUpdatedFlag();
    }
    const { poBoxCityUpdated } = this.props;
    if (poBoxCityUpdated && !prevProps.poBoxCityUpdated) {
      this.setState({
        poBoxCityModalVisibility: false,
      });
      // update state province
      const poBoxCity = cities.find(
        (item) => item.ciId === this.state.poBoxCity
      );
      const newPoBoxStateProvince = stateProvinces.find(
        (item) => item.spId === poBoxCity.ciStateProvinceRef
      );
      if (newPoBoxStateProvince && newPoBoxStateProvince.spId) {
        this.setState({
          poBoxStateProvinceReference: newPoBoxStateProvince.spId,
          poBoxStateProvinceReferenceError: false,
        });
      } else {
        this.setState({
          poBoxStateProvinceReference: null,
          poBoxStateProvinceReferenceError: false,
        });
      }
      message.success("A City name is updated.");
      resetCityUpdatedFlag();
    }

    const { postalCodeCreated, resetPostalCodeCreatedFlag } = this.props;
    if (postalCodeCreated !== null && prevProps.postalCodeCreated === null) {
      this.setState({
        postalCodeModalVisibility: false,
        postalCode: postalCodeCreated,
        postalCodeError: false,
      });
      message.success("A new Postal Code is created.");
      resetPostalCodeCreatedFlag();
    }

    const { postalCodeUpdated, resetPostalCodeUpdatedFlag } = this.props;
    if (postalCodeUpdated && !prevProps.postalCodeUpdated) {
      this.setState({
        postalCodeModalVisibility: false,
      });
      message.success("Postal Code is updated.");
      resetPostalCodeUpdatedFlag();
    }

    const { poBoxPostalCodeCreated } = this.props;
    if (
      poBoxPostalCodeCreated !== null &&
      prevProps.poBoxPostalCodeCreated === null
    ) {
      this.setState({
        poBoxPostalCodeModalVisibility: false,
        poBoxZipCode: poBoxPostalCodeCreated,
        poBoxZipCodeError: false,
      });
      message.success("A new Postal Code is created.");
      resetPostalCodeCreatedFlag();
    }

    const { poBoxPostalCodeUpdated } = this.props;
    if (poBoxPostalCodeUpdated && !prevProps.poBoxPostalCodeUpdated) {
      this.setState({
        poBoxPostalCodeModalVisibility: false,
      });
      message.success("Postal Code is updated.");
      resetPostalCodeUpdatedFlag();
    }

    const { bpCreated, resetBPCreatedFlag } = this.props;
    if (bpCreated && !prevProps.bpCreated) {
      // new bp is created, show message to user;
      message.success("New business partner is created.");
      resetBPCreatedFlag();

      const roles = bpTypes.map((item) => ({ ...item, checked: true }));
      this.setState({ ...initialState, roles });
    }

    const { bpUpdated, resetBPUpdatedFlag, history } = this.props;
    if (bpUpdated && !prevProps.bpUpdated) {
      // new bp is Updated, show message to user;
      message.success("Business Partner is updated.");
      // reset bpUpdated and bpRejected flag
      resetBPUpdatedFlag();
      history.push("/");
    }

    const { bpRejected } = this.props;
    if (bpRejected && !prevProps.bpRejected) {
      // new bp is rejected, show message to user;
      message.success("Business Partner is rejected.");
      // reset bpUpdated and bpRejected flag
      resetBPUpdatedFlag();
      const roles = bpTypes.map((item) => ({ ...item, checked: true }));
      this.setState({ ...initialState, roles });
      history.replace("/rejected-business-partners");
    }

    const { selectedBP, fetchCitiesAndPostalCodesByCountry } = this.props;
    if (selectedBP && prevProps.selectedBP === null) {
      fetchCitiesAndPostalCodesByCountry(selectedBP.bpCountryRef);
      this.setUpdatedState(selectedBP);
    } else {
      if (
        selectedBP &&
        prevProps.selectedBP &&
        this.props.selectedBP.bpId !== prevProps.selectedBP.bpId
      ) {
        fetchCitiesAndPostalCodesByCountry(selectedBP.bpCountryRef);
        this.setUpdatedState(selectedBP);
      }
    }
    const { deleteBPSucceeded, resetDeleteBPSucceeded } = this.props;
    if (deleteBPSucceeded && !prevProps.deleteBPSucceeded) {
      message.success("A business parter was deleted.");
      resetDeleteBPSucceeded();
      const roles = bpTypes.map((item) => ({ ...item, checked: true }));
      this.setState({ ...initialState, roles });
      history.replace("/");
    }

    // track changein bpID in url
    const { retainUpdatedBusinessParter } = this.props;
    if (match.params.bpID !== prevProps.match.params.bpID) {
      if (match.params.bpID) {
        const { bpID } = match.params;
        retainUpdatedBusinessParter(bpID);
      }
    }

    const { bpActivated } = this.props;
    if (bpActivated && !prevProps.bpActivated) {
      // new bp is rejected, show message to user;
      message.success("Business Partner is approved.");
      // reset bpUpdated and bpRejected flag
      resetBPUpdatedFlag();
      const roles = bpTypes.map((item) => ({ ...item, checked: true }));
      this.setState({ ...initialState, roles });
      history.replace("/");
    }

    const { bicSwifts } = this.props;
    const { bicSwift, bank, selectedRole } = this.state;
    if ((prevProps.bicSwifts === null && bicSwifts) || (bicSwifts && !bank)) {
      if (bicSwift) {
        const bicSwiftObj = bicSwifts.find(
          (item) => item.bicSwiftCode === bicSwift
        );
        if (bicSwiftObj) {
          this.setState({ bank: bicSwiftObj.bankName });
        }
      }
    }
    if (prevState.selectedRole !== selectedRole) {
      // role is updated
      this.buildExternalSystemRoles(selectedRole);
    }

    const { countries } = this.props;
    // only fetch record data after fetching lookup/countries data
    if (prevProps.countries === null && countries) {
      if (match.params.bpID) {
        const { bpID } = match.params;
        retainUpdatedBusinessParter(bpID);
      }
    }
  }

  componentWillUnmount() {
    const { resetSelectedBP } = this.props;
    resetSelectedBP();
  }

  isSepaCountry(countryID?: number) {
    const { bankCountry } = this.state;
    const { countries } = this.props;

    let isSepaCountry = false;
    const bankCountryID = countryID || bankCountry;
    if (bankCountryID && countries) {
      const country = countries.find((item) => item.coId === bankCountryID);
      isSepaCountry = country.coSepaCheck;
    }
    return isSepaCountry;
  }

  isEUCountry(countryID: number) {
    const { countries } = this.props;
    const country =
      countries && countries.find((item) => item.coId === countryID);
    return country && country.coEUCheck;
  }

  setViesCountryCode(countryID: number) {
    const { countries } = this.props;
    const country =
      countries && countries.find((item) => item.coId === countryID);
    const isViesCountryEU = country ? country.coEUCheck : false;
    this.setState({
      viesCountryCode: isViesCountryEU ? country.coCountry : "",
    });
  }

  setUpdatedState = (obj: BusinessPartnerType) => {
    const bankCountryId =
      obj.bankAccount.length > 0 ? obj.bankAccount[0].baCountryRef : undefined;
    const sepaCountry = this.isSepaCountry(bankCountryId);
    const bicSwift =
      obj.bankAccount.length > 0 ? obj.bankAccount[0].baBankBICSWIFT : null;
    const bankCountry =
      obj.bankAccount.length > 0 ? obj.bankAccount[0].baCountryRef : null;

    const isIBAN =
      obj.bankAccount.length > 0 ? obj.bankAccount[0].baIban !== "" : true;
    const viesCountry =
      obj.taxNumber.length > 0 ? obj.taxNumber[0].tnVIESNumberCountryRef : null;
    let taxNumber =
      obj.taxNumber.length > 0 ? obj.taxNumber[0].tnVIESNumber || "" : "";
    taxNumber = taxNumber.substr(2);

    this.setViesCountryCode(viesCountry);
    const isEUCountry = this.isEUCountry(obj.bpCountryRef);
    this.setState({ isEUCountry });

    this.setState(
      {
        bpId: obj.bpId,
        mode: "update",
        businessPartnerNameOne: obj.bpName,
        businessPartnerNameTwo: obj.bpName2 || "",
        businessPartnerNameTwoError: false,
        searchName: obj.bpSearchName,
        website: obj.bpWebsite || "",
        telephoneNumber: obj.bpPhoneNr || "",
        email: obj.bpEmail || "",
        streetOne: obj.bpStreet,
        countryReference: obj.bpCountryRef,
        sepaCountry,
        currencyReferrence: obj.bpCurrencyRef,
        poBoxZipCode: obj.bpPoboxZipcode || null,
        dunsNumber: obj.bpDuns || "",
        houseNumber: obj.bpHouseNr || "",
        postOfficeBox: obj.bpPobox || "",
        poBoxCity: obj.bpPoboxCityRef,
        stateProvinceReference: obj.bpStateProvinceRef || null,
        postalCode: obj.bpPostalcodeRef,
        taxNumber,
        viesCountry,
        viesCountryError: false,
        intTaxNumber:
          obj.taxNumber.length > 0 ? obj.taxNumber[0].tnIntTaxNumber || "" : "",
        intTaxCountry:
          obj.taxNumber.length > 0
            ? obj.taxNumber[0].tnIntTaxNumberCountryRef
            : null,
        intTaxCountryError: false,

        nationalVATNumber:
          obj.taxNumber.length > 0
            ? obj.taxNumber[0].tnLocalTaxNumber || ""
            : "",
        localTaxCountry:
          obj.taxNumber.length > 0
            ? obj.taxNumber[0].tnLocalTaxNumberCountryRef
            : null,
        localTaxCountryError: false,

        bankAccountNumber:
          obj.bankAccount.length > 0
            ? (obj.bankAccount[0].baIban &&
                obj.bankAccount[0].baIban.replace(/ /g, "")) ||
              obj.bankAccount[0].baNumber
            : "",
        bicSwift,
        bankCountry,
        yearlyTurnover: obj.bpYearlyTurnover || null,
        chamberOfCommerce: obj.bpChamberOfCommerceNr || "",
        city: obj.bpCityRef,
        cityError: false,
        businessPartnerNameOneError: false,
        streetOneError: false,
        currencyReferrenceError: false,
        telephoneNumberError: false,
        telephoneAreaCodeError: false,
        emailError: false,
        countryReferenceError: false,
        stateProvinceReferenceError: false,
        postalCodeError: false,
        selectedRole:
          (obj.pseudoRoleBpmap &&
            obj.pseudoRoleBpmap.length > 0 &&
            obj.pseudoRoleBpmap[0].pbConstantRef) ||
          1,
        paymentTerms: obj.bpPaymentTerms,
        paymentTermsError: false,
        // nationalVATNumber: obj.bpNatVATNumber,
        relevantPlants: obj.bpReleventPlant,
        relevantPlantsError: false,
        comments: obj.bpComment,
        isIBAN,
        poBoxStateProvinceReference: obj.bpPoboxStateProvinceRef,
        poBoxCountryReference: obj.bpCountryRef,
        isEUCountry,
      },
      () => {
        const { selectedRole } = this.state;
        this.buildExternalSystemRoles(selectedRole);
        this.setViesCountryCode(viesCountry);
      }
    );
    // fetch bicSwift list of bank country
    if (bankCountry) {
      const { countries, fetchBicSwifts } = this.props;
      const country =
        countries && countries.find((item) => item.coId === bankCountry);
      if (country) fetchBicSwifts(country.coCountry);
    }
    if (bicSwift) {
      const { fetchBankBranch } = this.props;
      fetchBankBranch(bicSwift);
    }
  };

  formChangeHandler = (
    value: any,
    field: string,
    fieldError: string,
    extra?: ExtraType
  ) => {
    switch (field) {
      case "yearlyTurnover": {
        if (!isNumeric(value) && value.trim() !== "") return;
        this.setState((prevState) => ({
          ...prevState,
          [field]: value,
          [fieldError]: false,
        }));
        break;
      }
      case "countryReference": {
        const {
          flushCountryDependentLookupData,
          fetchCitiesAndPostalCodesByCountry,
        } = this.props;
        flushCountryDependentLookupData();
        const sepaCountry = this.isSepaCountry();
        const isEUCountry = this.isEUCountry(value);
        if (value) {
          fetchCitiesAndPostalCodesByCountry(value);
        }

        this.setState((prevState: BusinessPartnerStates) => ({
          ...prevState,
          [field]: value || null,
          [fieldError]: value === "",
          postalCode: null,
          postalCodeError: false,
          city: null,
          cityError: false,
          stateProvinceReference: null,
          stateProvinceReferenceError: false,
          sepaCountry,
          poBoxCountryReference: value || null,
          poBoxCity: null,
          poBoxCityError: false,
          poBoxStateProvinceReference: null,
          poBoxStateProvinceReferenceError: false,
          poBoxZipCode: null,
          poBoxZipCodeError: false,
          isEUCountry,
        }));
        if (isEUCountry) {
          this.setState({
            intTaxCountry: null,
            intTaxNumber: "",
          });
        }
        break;
      }
      case "bankAccountNumber": {
        if (value === "") {
          this.setState((prevState) => ({
            ...prevState,
            bankAccountNumber: value.replace(/ /g, "").trim(),
            bankAccountNumberError: false,
            bankIBANError: false,
            bankCountry: null,
            bankCountryError: false,
            bicSwift: null,
            bicSwiftError: false,
            bank: null,
            sepaCountry: false,
          }));
          const { resetBicSwifts, resetBankBranch } = this.props;
          resetBicSwifts();
          resetBankBranch();
        } else {
          this.setState((prevState) => ({
            ...prevState,
            bankAccountNumber: value.replace(/ /g, "").trim(),
            bankAccountNumberError: false,
            bankIBANError: false,
            bankCountryError: false,
            bicSwiftError: false,
          }));
        }
        break;
      }
      case "city": {
        // check if it has state province reference data
        // if it has update staet province automatically here
        const { stateProvinces } = this.props;
        const spId = extra && extra.data ? extra.data["data-spid"] : null;
        const stateProvince = stateProvinces.find((sp) => sp.spId === spId);
        if (stateProvince) {
          this.setState((prevState: BusinessPartnerStates) => ({
            ...prevState,
            [field]: value || null,
            [fieldError]: false,
            stateProvinceReference: spId,
            stateProvinceReferenceError: false,
          }));
        } else {
          this.setState((prevState: BusinessPartnerStates) => ({
            ...prevState,
            [field]: value || null,
            [fieldError]: false,
          }));
        }
        break;
      }
      case "stateProvinceReference": {
        this.setState((prevState) => ({
          ...prevState,
          [field]: value || null,
          [fieldError]: false,
          city: null,
          cityError: false,
        }));
        break;
      }
      case "poBoxStateProvinceReference": {
        this.setState((prevState) => ({
          ...prevState,
          [field]: value || null,
          [fieldError]: false,
          poBoxCity: null,
          poBoxCityError: false,
        }));
        break;
      }
      case "postalCode": {
        this.setState((prevState) => ({
          ...prevState,
          [field]: value || null,
          [fieldError]: false,
        }));
        break;
      }
      case "bankCountry": {
        const sepaCountry = this.isSepaCountry(value);

        if (sepaCountry) {
          this.setState({ isIBAN: true });
        }

        if (value) {
          this.setState((prevState) => ({
            ...prevState,
            [field]: value,
            [fieldError]: false,
            bicSwift: null,
            bicSwiftError: false,

            bank: "",
            sepaCountry,
          }));

          const bankCountryCode = extra.data && extra.data["data-country-code"];
          const { fetchBicSwifts } = this.props;
          fetchBicSwifts(bankCountryCode);
        } else {
          this.setState((prevState) => ({
            ...prevState,
            [field]: value,
            [fieldError]: false,
            bicSwift: null,
            bicSwiftError: false,
            bank: null,
            sepaCountry,
            bankAccountNumberError: false,
            bankIBANError: false,
          }));
        }
        const { resetBicSwifts, resetBankBranch } = this.props;
        resetBicSwifts();
        resetBankBranch();
        break;
      }
      case "bicSwift": {
        this.setState((prevState) => ({
          ...prevState,
          [field]: value,
          [fieldError]: false,
          // bank: extra.data && extra.data["data-bank"],
        }));
        const { fetchBankBranch, resetBankBranch } = this.props;
        if (value) {
          fetchBankBranch(value);
        } else {
          resetBankBranch();
        }

        break;
      }
      case "poBoxCity": {
        const { stateProvinces } = this.props;
        const spId = extra && extra.data ? extra.data["data-spid"] : null;
        const stateProvince = stateProvinces.find((sp) => sp.spId === spId);
        if (stateProvince) {
          this.setState((prevState: BusinessPartnerStates) => ({
            ...prevState,
            [field]: value || null,
            [fieldError]: false,
            poBoxStateProvinceReference: spId,
            poBoxStateProvinceReferenceError: false,
          }));
        } else {
          this.setState((prevState: BusinessPartnerStates) => ({
            ...prevState,
            [field]: value || null,
            [fieldError]: false,
          }));
        }
        break;
      }
      case "taxNumber": {
        this.setState((prevState) => ({
          ...prevState,
          [field]: (value || "").trim(),
          [fieldError]: false,
          euTaxError: false,
          nonEUTaxError: false,
        }));
        break;
      }
      case "nationalVATNumber": {
        this.setState((prevState) => ({
          ...prevState,
          [field]: value,
          [fieldError]: false,
          euTaxError: false,
          nonEUTaxError: false,
        }));
        break;
      }
      case "intTaxNumber": {
        this.setState((prevState) => ({
          ...prevState,
          [field]: value,
          [fieldError]: false,
          euTaxError: false,
          nonEUTaxError: false,
        }));
        break;
      }
      case "viesCountry": {
        this.setViesCountryCode(value);
        this.setState((prevState) => ({
          ...prevState,
          [field]: value,
          [fieldError]: false,
          // taxNumber: "",
        }));
        break;
      }
      default: {
        this.setState((prevState) => ({
          ...prevState,
          [field]: value,
          [fieldError]: false,
        }));
      }
    }
  };

  checkHasSupplierRole = () => {
    const { selectedRole } = this.state;
    return selectedRole === 2;
  };

  validateBPForm = () => {
    let formHasError = false;
    const {
      email,
      website,
      businessPartnerNameOne,
      countryReference,
      telephoneNumber,
      streetOne,
      postalCode,
      city,
      currencyReferrence,
      bankAccountNumber,
      selectedRole,
      stateProvinceReference,
      businessPartnerNameTwo,
    } = this.state;
    // check business partner name
    if (businessPartnerNameOne.trim() === "") {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        businessPartnerNameOneError: true,
      }));
    }
    if (businessPartnerNameTwo.trim().length > 30) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        businessPartnerNameTwoError: true,
      }));
    }
    // check BP country
    if (!!countryReference === false) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        countryReferenceError: true,
      }));
    }

    // check state province
    if (
      this.checkStateProvinceRequired() &&
      !!stateProvinceReference === false
    ) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        stateProvinceReferenceError: true,
      }));
    }
    // check street
    if (streetOne.trim() === "" || streetOne.trim().length > 30) {
      formHasError = true;
      this.setState((prevState) => ({ ...prevState, streetOneError: true }));
    }
    // check postal code
    if (!!postalCode === false) {
      formHasError = true;
      this.setState((prevState) => ({ ...prevState, postalCodeError: true }));
    }

    // check city
    if (!!city === false) {
      formHasError = true;
      this.setState((prevState) => ({ ...prevState, cityError: true }));
    }

    // check currency
    if (!!currencyReferrence === false) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        currencyReferrenceError: true,
      }));
    }

    // check email
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})/;
    if (email.trim() !== "" && emailRegex.test(email) === false) {
      formHasError = true;
      this.setState((prevState) => ({ ...prevState, emailError: true }));
    }

    // check website
    const websiteRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}(\/\S*)?$/gi;
    if (website.trim() !== "" && websiteRegex.test(website) === false) {
      formHasError = true;
      this.setState((prevState) => ({ ...prevState, websiteError: true }));
    }
    // telephone regex extracted from : https://stackoverflow.com/questions/2113908/what-regular-expression-will-match-valid-international-phone-numbers
    const telephoneNumberRegex = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
    if (
      telephoneNumber.trim() !== "" &&
      telephoneNumberRegex.test(telephoneNumber) === false
    ) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        telephoneNumberError: true,
      }));
    }

    // check bank Account number
    const hasSupplierRole = this.checkHasSupplierRole();
    if (hasSupplierRole && !!bankAccountNumber === false) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        bankAccountNumberError: true,
      }));
    }
    // if bank, IBAN/Bank Number and Country are there, check for sepa check and
    // validate IBAN Number
    const { isIBAN, bankCountry } = this.state;
    const { countries } = this.props;
    if (isIBAN) {
      if (bankCountry) {
        if (!IBAN.isValid(bankAccountNumber)) {
          formHasError = true;
          this.setState((prevState) => ({ ...prevState, bankIBANError: true }));
        } else {
          const ibanBankCode = bankAccountNumber.substring(0, 2).toUpperCase();
          const ibanBank = countries.find(
            (country) => country.coCountry === ibanBankCode
          );
          if (!ibanBank || ibanBank.coId !== bankCountry) {
            formHasError = true;
            this.setState((prevState) => ({
              ...prevState,
              bankCountryError: true,
            }));
          }
        }
      }
    } else if (bankCountry) {
      if (!bankAccountNumber) {
        formHasError = true;
        this.setState((prevState) => ({
          ...prevState,
          bankAccountNumberError: true,
        }));
      }
    }
    // check for Role
    if (selectedRole === null) {
      formHasError = true;
      this.setState((prevState) => ({ ...prevState, selectedRoleError: true }));
    }

    // if eu country then
    // either  viesnumber / internal tax number / local tax should be fileld
    // else flag euTaxerror
    const {
      isEUCountry,
      taxNumber,
      intTaxNumber,
      nationalVATNumber,
      viesCountry,
      localTaxCountry,
      intTaxCountry,
    } = this.state;
    if (countryReference) {
      if (isEUCountry) {
        if (
          taxNumber.trim() === "" &&
          intTaxNumber.trim() === "" &&
          nationalVATNumber.trim() === ""
        ) {
          formHasError = true;
          this.setState({ euTaxError: true });
        } else {
          this.setState({ euTaxError: false });
        }
      } else if (
        taxNumber.trim() === "" &&
        nationalVATNumber.trim() === "" &&
        intTaxNumber.trim() === ""
      ) {
        formHasError = true;
        this.setState({ nonEUTaxError: true });
      } else {
        this.setState({ nonEUTaxError: false });
      }

      const alphaNumericRegex = new RegExp(/^[a-zA-Z0-9]*$/);
      if (
        taxNumber.trim() !== "" &&
        alphaNumericRegex.test(taxNumber) === false
      ) {
        formHasError = true;
        this.setState({ taxNumberError: true });
      } else {
        this.setState({ taxNumberError: false });
      }
    }

    if (taxNumber.trim() !== "" && !viesCountry) {
      formHasError = true;
      this.setState({ viesCountryError: true });
    } else {
      this.setState({ viesCountryError: false });
    }
    if (intTaxNumber.trim() !== "" && !intTaxCountry) {
      formHasError = true;
      this.setState({ intTaxCountryError: true });
    } else {
      this.setState({ intTaxCountryError: false });
    }
    if (nationalVATNumber.trim() !== "" && !localTaxCountry) {
      formHasError = true;
      this.setState({ localTaxCountryError: true });
    } else {
      this.setState({ localTaxCountryError: false });
    }

    // if non eu country then
    // either vies number or local tax number should be filled
    // else flag nonEUTax error

    // check for Bank Country
    if (hasSupplierRole || this.state.bankAccountNumber) {
      if (!!this.state.bankCountry === false) {
        formHasError = true;
        this.setState((prevState) => ({
          ...prevState,
          bankCountryError: true,
        }));
      } else {
        // if sepa country then match iban number country and bank country
        // if not show error message in bank country field
        if (this.state.sepaCountry && this.state.bankAccountNumber.length > 1) {
          const ibanBankCode = this.state.bankAccountNumber
            .substring(0, 2)
            .toUpperCase();
          const ibanBank = this.props.countries.find(
            (country) => country.coCountry === ibanBankCode
          );
          // if invalid iban country or country do not match with bank Country

          if (!IBAN.isValid(this.state.bankAccountNumber)) {
            this.setState((prevState) => ({
              ...prevState,
              bankCountryError: false,
            }));
          } else {
            if (!!ibanBank && ibanBank.coId !== this.state.bankCountry) {
              formHasError = true;
              this.setState((prevState) => ({
                ...prevState,
                bankCountryError: true,
              }));
            }
          }
        }
      }
    }
    // check for BIC/SWIFT
    if (
      (hasSupplierRole && !!this.state.bicSwift === false) ||
      (this.state.bankAccountNumber && !!this.state.bicSwift === false)
    ) {
      formHasError = true;
      this.setState((prevState) => ({ ...prevState, bicSwiftError: true }));
    }
    if (
      hasSupplierRole &&
      (this.state.yearlyTurnover === null ||
        !!this.state.yearlyTurnover.toString().trim() === false)
    ) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        yearlyTurnoverError: true,
      }));
    }
    if (hasSupplierRole && !!this.state.paymentTerms.trim() === false) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        paymentTermsError: true,
      }));
    }

    if (!!this.state.relevantPlants === false) {
      formHasError = true;
      this.setState((prevState) => ({
        ...prevState,
        relevantPlantsError: true,
      }));
    }
    const { postOfficeBox } = this.state;
    // if valid post office box is present
    if (postOfficeBox) {
      // check if valid po box city is selected
      if (!!this.state.poBoxCity === false) {
        formHasError = true;
        this.setState((prevState) => ({
          ...prevState,
          poBoxCityError: true,
        }));
      }
      // check if valid po box state is selected
      if (
        this.checkStateProvinceRequired() &&
        !!this.state.poBoxStateProvinceReference === false
      ) {
        formHasError = true;
        this.setState((prevState) => ({
          ...prevState,
          poBoxStateProvinceReferenceError: true,
        }));
      }
      // check if valid po box zip code is selected
      if (!!this.state.poBoxZipCode === false) {
        formHasError = true;
        this.setState((prevState) => ({
          ...prevState,
          poBoxZipCodeError: true,
        }));
      }
    }

    this.setState({ activePanels: ["1", "2", "3", "4"] });
    if (formHasError) message.error("Please review the form field with error.");
    return formHasError;
  };

  getTargetSytemRolesPayload = () => {
    let isManuallyEdited = false;
    const { externalSystems } = this.state;
    let targetSystemRoles = [];
    // if edit roles manually is checked
    Object.keys(externalSystems).forEach((key) => {
      // eg DCW/ INFORLN object
      const externalSystem = externalSystems[key];

      Object.keys(externalSystem).forEach((subRoleKey) => {
        // SOLD-TO , INVOICE-To, SHIP-TO etc object with array of roles
        // if only one roles is present that means no external id is added.
        const externalSystemRoles = externalSystem[subRoleKey];

        const roles = externalSystemRoles.map((role) => {
          isManuallyEdited =
            isManuallyEdited ||
            role.originalValue !== role.tsrExternalId ||
            role.tsrManual;
          const {
            tsrExternalId,
            tsrManual,
            tsrRoleRef,
            tsrTargetSystemRef,
            tsrId,
          } = role;

          const targetSystemRole = {
            tsrExternalId,
            tsrManual,
            tsrRoleRef,
            tsrTargetSystemRef,
          };
          if (tsrId) {
            targetSystemRole.tsrId = tsrId;
          }
          return targetSystemRole;
        });

        if (roles.length > 1 && !roles[0].tsrExternalId) roles.shift();
        targetSystemRoles = targetSystemRoles.concat(roles);
      });
    });

    return {
      targetSystemRoles,
      isManuallyEdited,
    };
  };

  createBusinessPartner = () => {
    if (this.validateBPForm()) return;

    const { statuses } = this.props;
    const newStatus =
      statuses && statuses.find((item) => item.coValue.toLowerCase() === "new");

    const bankAccount = [];
    if (
      this.props.bankBranch &&
      this.state.bankAccountNumber.trim() &&
      this.state.bankCountry &&
      this.state.bicSwift
    ) {
      if (this.state.isIBAN) {
        bankAccount.push({
          baNumber: "",
          baIban: this.state.bankAccountNumber.replace(/ /g, ""),
          baBankBICSWIFT: this.state.bicSwift,
          baCountryRef: this.state.bankCountry,
          baBusinessPartnerRef: this.state.bpId,
        });
      } else {
        bankAccount.push({
          baNumber: this.state.bankAccountNumber.trim(),
          baBankBICSWIFT: this.state.bicSwift,
          baCountryRef: this.state.bankCountry,
          baBusinessPartnerRef: this.state.bpId,
          baIban: "",
        });
      }
    }

    let {
      targetSystemRoles,
      isManuallyEdited,
    } = this.getTargetSytemRolesPayload();

    // if any one of the roles record is manually edited set all to manually edited
    if (isManuallyEdited) {
      targetSystemRoles = targetSystemRoles.map((role) => ({
        ...role,
        tsrManual: isManuallyEdited,
      }));
    } else {
      targetSystemRoles = [];
    }

    const payload = {
      bpStatus: newStatus && newStatus.coId,
      bpName: this.state.businessPartnerNameOne.trim(),
      bpName2: this.state.businessPartnerNameTwo.trim(),
      bpSearchName: this.state.searchName.trim(),
      bpStreet: this.state.streetOne.trim(),
      bpHouseNr: this.state.houseNumber.trim(),
      bpPhoneNr: this.state.telephoneNumber.trim(),
      bpPobox: this.state.postOfficeBox.trim(),
      bpPoboxZipcode: this.state.poBoxZipCode,
      bpPoboxCityRef: this.state.poBoxCity,
      bpWebsite: this.state.website.trim(),
      bpEmail: this.state.email.trim(),
      bpDuns: this.state.dunsNumber.trim(),
      bpYearlyTurnover: this.state.yearlyTurnover,
      bpChamberOfCommerceNr: this.state.chamberOfCommerce.trim(),
      bpPostalcodeRef: this.state.postalCode,
      bpPoboxStateProvinceRef: this.state.poBoxStateProvinceReference,
      bpCityRef: this.state.city,
      bpCountryRef: this.state.countryReference,
      bpStateProvinceRef: this.state.stateProvinceReference,
      bpLanguageRef: "",
      bpCurrencyRef: this.state.currencyReferrence,
      bankAccount,
      pseudoRoleBpmap: [
        {
          pbConstantRef: this.state.selectedRole,
        },
      ],
      taxNumber: [
        {
          tnBusinessPartnerRef: this.state.bpId,
          tnCountryRef: this.state.countryReference,
          tnIntTaxNumber: this.state.intTaxNumber,
          tnIntTaxNumberCountryRef: this.state.intTaxCountry,
          tnLocalTaxNumber: this.state.nationalVATNumber,
          tnLocalTaxNumberCountryRef: this.state.localTaxCountry,
          tnVIESNumberCountryRef: this.state.viesCountry,
          tnVIESNumber:
            this.state.taxNumber.trim() !== ""
              ? (this.state.viesCountryCode || "") + this.state.taxNumber.trim()
              : "",
        },
      ],
      baCountryRef: this.state.bankCountry,
      targetSystemRoles,
      bpNatVATNumber: this.state.nationalVATNumber.trim(),
      bpPaymentTerms: this.state.paymentTerms.trim(),
      bpComment: this.state.comments.trim(),
      bpReleventPlant: this.state.relevantPlants.trim(),
    };
    this.props.createBusinessPartner(payload);
  };

  togglePostalCodeModal = () => {
    this.setState({
      postalCodeModalVisibility: !this.state.postalCodeModalVisibility,
    });
  };

  togglePoBoxPostalCodeModal = () => {
    this.setState({
      poBoxPostalCodeModalVisibility: !this.state
        .poBoxPostalCodeModalVisibility,
    });
  };

  toggleCityModal = () => {
    this.setState({ cityModalVisibility: !this.state.cityModalVisibility });
  };

  getCountryNameByID(countryID: number | null) {
    if (!countryID) return "";
    const { countries } = this.props;
    const country = countries.find((item) => item.coId === countryID);
    return country.coDescription;
  }

  updateBusinessPartner = () => {
    if (this.validateBPForm()) return;
    const { selectedBP } = this.props;
    const baId =
      selectedBP.bankAccount.length > 0 ? selectedBP.bankAccount[0].baId : null;

    const pseudoRoleBpmap = [];
    if (selectedBP.pseudoRoleBpmap.length > 0) {
      let { pbId } = selectedBP.pseudoRoleBpmap[0];
      pseudoRoleBpmap.push({
        pbId,
        pbConstantRef: this.state.selectedRole,
        pbBusinessPartnerRef: this.state.bpId,
      });
    }

    const bankAccount = [];
    let bankAccountObj: BankAccountNumberType;
    if (
      this.state.bankAccountNumber.trim() ||
      // this.props.bankBranch ||
      this.state.bankCountry ||
      this.state.bicSwift
    ) {
      if (this.state.isIBAN) {
        bankAccountObj = {
          baNumber: "",
          baBankBICSWIFT: this.state.bicSwift,
          baCountryRef: this.state.bankCountry,
          baBusinessPartnerRef: this.state.bpId,
          baIban: this.state.bankAccountNumber.replace(/ /g, ""),
        };
      } else {
        bankAccountObj = {
          baNumber: this.state.bankAccountNumber.trim(),
          baBankBICSWIFT: this.state.bicSwift,
          baCountryRef: this.state.bankCountry,
          baBusinessPartnerRef: this.state.bpId,
          baIban: "",
        };
      }
      if (selectedBP.bankAccount.length > 0) {
        bankAccountObj["baId"] = baId;
      }
      bankAccount.push(bankAccountObj);
    }
    const taxNumber = [];
    const taxNumberObject = {
      tnBusinessPartnerRef: this.state.bpId,
      tnId: selectedBP.taxNumber.length > 0 ? selectedBP.taxNumber[0].tnId : 0,
      tnIntTaxNumber: this.state.intTaxNumber,
      tnIntTaxNumberCountryRef:
        this.state.intTaxNumber.trim() !== "" ? this.state.intTaxCountry : null,
      tnLocalTaxNumber: this.state.nationalVATNumber,
      tnLocalTaxNumberCountryRef: this.state.nationalVATNumber
        ? this.state.localTaxCountry
        : null,
      tnVIESNumber:
        this.state.taxNumber.trim() !== ""
          ? (this.state.viesCountryCode || "") + this.state.taxNumber.trim()
          : "",
      tnVIESNumberCountryRef: this.state.taxNumber.trim()
        ? this.state.viesCountry
        : null,
    };
    taxNumber.push(taxNumberObject);


    let {
      targetSystemRoles,
      isManuallyEdited,
    } = this.getTargetSytemRolesPayload();

    // if any one of the roles record is manually edited set all to manually edited
    if (selectedBP.targetSystemRoles.length === 0) {
      if (isManuallyEdited) {
        // ealirer there was no target system roles in bp but now manual edit is detedted.
        targetSystemRoles = targetSystemRoles.map((role) => ({
          ...role,
          tsrManual: isManuallyEdited,
        }));
      } else {
        // earlier there was no target sytem roles and no manual edit was detected.
        targetSystemRoles = [];
      }
    } else {
      targetSystemRoles = targetSystemRoles.map((role) => ({
        ...role,
        tsrManual: isManuallyEdited,
      }));
    }

    // in case any external id is deleted only
    if (
      selectedBP.targetSystemRoles.length !== targetSystemRoles.length &&
      targetSystemRoles.length > 0
    ) {
      targetSystemRoles = targetSystemRoles.map((role) => ({
        ...role,
        tsrManual: true,
      }));
    }

    const payload = {
      bpId: this.state.bpId,
      bpStatus: selectedBP.bpStatus >= 6 ? 7 : 4, // update status to CHanged if its already approved or new otherwise.
      bpName: this.state.businessPartnerNameOne.trim(),
      bpName2: this.state.businessPartnerNameTwo.trim(),
      bpSearchName: this.state.searchName.trim(),
      bpStreet: this.state.streetOne.trim(),
      bpHouseNr: this.state.houseNumber.trim(),
      bpPhoneNr: this.state.telephoneNumber.trim(),
      bpPobox: this.state.postOfficeBox.trim(),
      bpPoboxZipcode: this.state.poBoxZipCode,
      bpPoboxCityRef: this.state.poBoxCity,
      bpWebsite: this.state.website.trim(),
      bpEmail: this.state.email.trim(),
      bpDuns: this.state.dunsNumber.trim(),
      bpYearlyTurnover: this.state.yearlyTurnover,
      bpChamberOfCommerceNr: this.state.chamberOfCommerce.trim(),
      bpPostalcodeRef: this.state.postalCode,
      bpCityRef: this.state.city,
      bpCountryRef: this.state.countryReference,
      bpStateProvinceRef: this.state.stateProvinceReference,
      bpLanguageRef: "",
      bpCurrencyRef: this.state.currencyReferrence,
      bpBankAccountRef: this.state.bank,
      bpNatVATNumber: this.state.nationalVATNumber.trim(),
      bpPaymentTerms: this.state.paymentTerms.trim(),
      bankAccount,
      pseudoRoleBpmap,
      taxNumber,
      baCountryRef: this.state.bankCountry,
      targetSystemRoles,
      bpComment: this.state.comments.trim(),
      bpReleventPlant: this.state.relevantPlants.trim(),
      bpPoboxStateProvinceRef: this.state.poBoxStateProvinceReference,
    };
    this.props.updateBusinessPartner(payload);
  };

  toggleRejectBPModal = () => {
    this.setState({
      rejectBPModalVisibility: !this.state.rejectBPModalVisibility,
    });
  };

  rejectBusinessPartner = (remark: string) => {
    const { selectedBP, msalContext } = this.props;
    const { bpAction, bpActionName, ...payload } = selectedBP;
    payload.bpStatus = 5;
    payload.bpRejectComment = [
      {
        brcComment: remark,
        brcPerson: msalContext.accounts[0].name || '', // userInfo.profile.name,
      },
    ];
    payload.changeLog = [
      {
        clPerson: msalContext.accounts[0].name || '', // this.props.userInfo.profile.name,
        clAction: "REJECTED",
        clBusinessPartnerRef: this.state.bpId,
        extendedData: {
          bpStatus: {
            original: selectedBP.bpStatusName.toUpperCase(),
            changed: "REJECTED",
          },
        },
      },
    ];
    this.props.updateBusinessPartner(payload);
  };

  approveBusinessPartner = () => {
    if (this.validateBPForm()) return;
    const { selectedBP, msalContext } = this.props;
    const { bpAction, bpActionName, ...payload } = selectedBP;
    payload.bpStatus = 6;
    payload.changeLog = [
      {
        clPerson: msalContext.accounts[0].name || '', // userInfo.profile.name,
        clAction: "APPROVED",
        clBusinessPartnerRef: this.state.bpId,
        extendedData: {
          bpStatus: {
            original: selectedBP.bpStatusName.toUpperCase(),
            changed: "APPROVED",
          },
        },
      },
    ];
    this.props.updateBusinessPartner(payload);
  };

  checkDuplicateOf = (e) => {
    const value = e.target.value;
    // handle keypress and check if the characters meet the length of 2
    if (e.keyCode === 13 && value.length >= 2) {
      const payload = {
        sortBy: "",
        isSortAscending: false,
        page: 1,
        pageSize: this.props.duplicateBPPagination.pageSize,
        genericSearch: value,
        searchData: [],
      };
      this.setState(
        { duplicateCheckInProgress: true },
        () =>
          !this.state.duplicateCheckInProgress &&
          this.props.checkDubplicateOf(payload)
      );
    }
  };

  onSearch = (value: string) => {
    if (value.length >= 2) {
      const payload = {
        sortBy: "",
        isSortAscending: false,
        page: 1,
        pageSize: this.props.duplicateBPPagination.pageSize,
        genericSearch: value,
        searchData: [],
      };
      this.props.checkDubplicateOf(payload);
    }
  };

  toggleDuplicateBPModal = () => {
    this.setState({
      duplicateBPModalVisibility: !this.state.duplicateBPModalVisibility,
    });
    if (this.state.duplicateBPModalVisibility) {
      this.props.resetDuplicateBPs();
    }
  };

  collaspPanel = (activePanels: string[]) => {
    this.setState({ activePanels });
  };

  buildExternalSystemRoles = (selectedRole: number) => {
    const { selectedBP, pseudoRoleMap } = this.props;

    const externalSystems = {};
    let targetSystemRoles = [];
    const pseudotargetSystemRoles = pseudoRoleMap
      ? pseudoRoleMap.filter((role) => role.prConstantRef === selectedRole)
      : [];

    // built state of the external system roles mapped from pseudo role based on selected role
    // externalSystemRoles Map<string, Object>
    // string : pseudorole__exteransystem__externalSystemRole__[tsrID|NULL__timeStamp]
    // object : {
    // tsrExternalId: ""
    // tsrId: 61218
    // tsrManual: null
    // tsrRoleRef: 1
    // tsrRoleRefName: "Sold-To"
    // tsrTargetSystemRefName: "InforLN"
    //}
    const externalSystemReferenceIDs = new Map();
    if (
      !selectedBP ||
      (selectedBP && selectedBP.targetSystemRoles.length === 0)
    ) {
      // create mode
      // eg, CUSTOMER__INFORLN__SOLD_TO__0, CUSTOMER__INFORLN__SOLD_TO__1, CUSTOMER__INFORLN__SOLD_TO__1,
      targetSystemRoles = pseudotargetSystemRoles.map((item) => {
        const key = `${item.prConstantRefName}__${
          item.prTargetSystemRefName
        }__${item.prRoleRefName}`;
        const roleValue = {
          tsrExternalId: "",
          tsrId: "",
          tsrManual: false,
          tsrRoleRef: item.prRoleRef,
          tsrRoleRefName: item.prRoleRefName,
          tsrTargetSystemRefName: item.prTargetSystemRefName,
          tsrTargetSystemRef: item.prTargetSystemRef,
          pseudoRole: item.prConstantRef,
          // pseudoRoleRef: item.prConstantRef,
          valid: false,
          tempID: null,
          mode: "read", // readonly / edit
          originalValue: "",
        };
        externalSystemReferenceIDs.set(key, roleValue);
        return roleValue;
      });

      // set state of
    } else {
      // edit mode
      // resort to target system role to create external system roles state

      targetSystemRoles = selectedBP.targetSystemRoles.map((item) => {
        const {
          tsrExternalId,
          tsrId,
          tsrManual,
          tsrRoleRef,
          tsrRoleRefName,
          tsrTargetSystemRefName,
          tsrTargetSystemRef,
        } = item;
        return {
          tsrExternalId,
          tsrId,
          tsrManual: false,
          tsrRoleRef,
          tsrRoleRefName,
          tsrTargetSystemRefName,
          tsrTargetSystemRef,
          pseudoRole: tsrRoleRef,
          // pseudoRoleRef: item.prConstantRef,
          valid: !!tsrExternalId,
          tempID: tsrId,
          mode: "read", // readonly / edit
          originalValue: tsrExternalId,
        };
      });
    }

    targetSystemRoles.forEach((item) => {
      if (externalSystems[item.tsrTargetSystemRefName] === undefined) {
        externalSystems[item.tsrTargetSystemRefName] = {};

        externalSystems[item.tsrTargetSystemRefName][item.tsrRoleRefName] = [];
      }
      if (
        externalSystems[item.tsrTargetSystemRefName][item.tsrRoleRefName] ===
        undefined
      ) {
        externalSystems[item.tsrTargetSystemRefName][item.tsrRoleRefName] = [];
      }
      externalSystems[item.tsrTargetSystemRefName][item.tsrRoleRefName].push(
        item
      );
    });
    this.setState({
      externalSystems,
    });
  };

  onRoleChange = (e) => {
    const { selectedBP, pseudoRoleMap } = this.props;
    const selectedRole = e.target.value;
    this.setState({
      selectedRole,
      selectedRoleError: false,
      bankError: false,
      bankAccountNumberError: false,
      bicSwiftError: false,
      bankCountryError: false,
      bankIBANError: false,
    });
  };

  copyBP = (record: BusinessPartnerType) => {
    const sepaCountry = this.isSepaCountry(
      record.bankAccount.length > 0
        ? record.bankAccount[0].baCountryRef
        : undefined
    );

    const bicSwift =
      record.bankAccount.length > 0
        ? record.bankAccount[0].baBankBICSWIFT
        : null;
    const bankCountry =
      record.bankAccount.length > 0 ? record.bankAccount[0].baCountryRef : null;
    const selectedRole =
      (record.pseudoRoleBpmap &&
        record.pseudoRoleBpmap.length > 0 &&
        record.pseudoRoleBpmap[0].pbConstantRef) ||
      1;

    const viesCountry =
      record.taxNumber.length > 0
        ? record.taxNumber[0].tnVIESNumberCountryRef
        : null;
    const isEUCountry = this.isEUCountry(record.bpCountryRef);

    let taxNumber =
      record.taxNumber.length > 0 ? record.taxNumber[0].tnVIESNumber || "" : "";
    taxNumber = taxNumber.substr(2);
    this.setState(
      {
        bpId: null,
        mode: "create",
        businessPartnerNameOne: record.bpName,
        businessPartnerNameTwo: record.bpName2,
        businessPartnerNameTwoError: false,
        searchName: record.bpSearchName.trim(),
        website: record.bpWebsite,
        telephoneNumber: record.bpPhoneNr,
        email: record.bpEmail,
        streetOne: record.bpStreet,
        countryReference: record.bpCountryRef,
        sepaCountry,
        currencyReferrence: record.bpCurrencyRef,
        poBoxZipCode: record.bpPoboxZipcode,
        dunsNumber: record.bpDuns,
        houseNumber: record.bpHouseNr,
        postOfficeBox: record.bpPobox,
        poBoxCity: record.bpPoboxCityRef,
        stateProvinceReference: record.bpStateProvinceRef || null,
        postalCode: record.bpPostalcodeRef,
        bankAccountNumber:
          record.bankAccount.length > 0
            ? (record.bankAccount[0].baIban &&
                record.bankAccount[0].baIban.replace(/ /g, "")) ||
              record.bankAccount[0].baNumber
            : "",
        bicSwift,
        bankCountry,
        yearlyTurnover: record.bpYearlyTurnover,
        chamberOfCommerce: record.bpChamberOfCommerceNr,
        city: record.bpCityRef,
        taxNumber,
        viesCountry,
        viesCountryError: false,
        intTaxNumber:
          record.taxNumber.length > 0
            ? record.taxNumber[0].tnIntTaxNumber || ""
            : "",
        intTaxCountry:
          record.taxNumber.length > 0
            ? record.taxNumber[0].tnIntTaxNumberCountryRef
            : null,
        intTaxCountryError: false,

        nationalVATNumber:
          record.taxNumber.length > 0
            ? record.taxNumber[0].tnLocalTaxNumber || ""
            : "",
        localTaxCountry:
          record.taxNumber.length > 0
            ? record.taxNumber[0].tnLocalTaxNumberCountryRef
            : null,
        localTaxCountryError: false,

        cityError: false,
        businessPartnerNameOneError: false,
        selectedRoleError: false,
        streetOneError: false,
        currencyReferrenceError: false,
        telephoneNumberError: false,
        telephoneAreaCodeError: false,
        emailError: false,
        countryReferenceError: false,
        stateProvinceReferenceError: false,
        postalCodeError: false,
        selectedRole,
        targetSystemRoles: [],
        externalSystems: {},
        paymentTerms: record.bpPaymentTerms,
        relevantPlants: record.bpReleventPlant,
        relevantPlantsError: false,
        comments: record.bpComment,
        isIBAN: true,
        poBoxStateProvinceReference: record.bpPoboxStateProvinceRef,
        poBoxCountryReference: record.bpCountryRef,
        isEUCountry,
      },
      () => {
        this.buildExternalSystemRoles(selectedRole);
        this.setViesCountryCode(viesCountry);
      }
    );

    // fetch bicSwift list of bank country
    if (bankCountry) {
      const country =
        this.props.countries &&
        this.props.countries.find((item) => item.coId === bankCountry);
      if (country) this.props.fetchBicSwifts(country.coCountry);
    }
    if (bicSwift) {
      this.props.fetchBankBranch(bicSwift);
    }

    this.props.fetchCitiesAndPostalCodesByCountry(record.bpCountryRef);
    this.props.resetSelectedBP();
  };

  deleteBusinessPartner = () => {
    Modal.confirm({
      title: "Are you sure?",
      content: "The record will be delete.",
      onOk: () => {
        this.props.deleteBusinessPartner(this.state.bpId);
      },
    });
  };

  rejectDelete = () => {
    const { selectedBP, msalContext } = this.props;
    const { bpAction, bpActionName, ...payload } = selectedBP;
    payload.bpStatus = 6;
    payload.changeLog = [
      {
        clPerson: msalContext.accounts[0].name || '', // this.props.userInfo.profile.name,
        clAction: "ACTIVE",
        clBusinessPartnerRef: this.state.bpId,
        extendedData: {
          bpStatus: {
            original: selectedBP.bpStatusName.toUpperCase(),
            changed: "ACTIVE",
          },
        },
      },
    ];

    this.props.updateBusinessPartner(payload);
  };

  setModeToUpdate = () => {
    this.setState({ mode: "update" });
  };

  toggleAddReferenceID = (baseKey: string) => {
    return () => {
      const nextValue = !this.state[`${baseKey}__add`];
      this.setState({ [`${baseKey}__add`]: nextValue });
    };
  };

  externalRefernceChangeHandler = ({ role, baseKey, newRole }) => {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      if (newRole) {
        this.setState({
          [`${baseKey}__newReferenceID`]: event.target.value,
        });
      } else {
        const { externalSystems } = this.state;
        const subRoles =
          externalSystems[role.tsrTargetSystemRefName][role.tsrRoleRefName];
        externalSystems[role.tsrTargetSystemRefName][
          role.tsrRoleRefName
        ] = subRoles.map((subRole) => {
          if (subRole.tempID === role.tempID) {
            return {
              ...subRole,
              tsrExternalId: event.target.value,
              tsrManual: true,
            };
          }
          return subRole;
        });
        this.setState({ externalSystems });
      }
    };
  };

  addExternalReferenceIDHandler = ({ role, baseKey }) => {
    return () => {
      const inputValue = this.state[`${baseKey}__newReferenceID`];

      if (!inputValue || (inputValue && inputValue.trim() === "")) {
        return;
      }
      const { externalSystems } = this.state;
      externalSystems[role.tsrTargetSystemRefName][role.tsrRoleRefName].push({
        ...role,
        tsrExternalId: inputValue,
        originalValue: inputValue,
        valid: true,
        tsrManual: true,
        tempID: new Date().getTime(),
        tsrId: null,
      });
      this.setState({
        externalSystems,
        [`${baseKey}__newReferenceID`]: "",
        [`${baseKey}__add`]: false,
      });
    };
  };

  deleteExternalReferenceIDHandler = ({ role }) => {
    return () => {
      const { externalSystems } = this.state;
      const subRoles =
        externalSystems[role.tsrTargetSystemRefName][role.tsrRoleRefName];
      if (role.tsrId && subRoles.length === 1) {
        // when only one record is present
        externalSystems[role.tsrTargetSystemRefName][role.tsrRoleRefName] = [
          {
            ...role,
            tsrExternalId: "",
            tsrId: "",
            tsrManual: true,
            valid: false,
            tempID: null,
            mode: "read",
            originalValue: "",
          },
        ];
      } else {
        externalSystems[role.tsrTargetSystemRefName][
          role.tsrRoleRefName
        ] = subRoles.filter((subRole) => subRole.tempID !== role.tempID);
      }
      this.setState({ externalSystems });
    };
  };

  toggleEditExternalRferenceIDHandler = ({ role }) => {
    return () => {
      const { externalSystems } = this.state;
      const subRoles =
        externalSystems[role.tsrTargetSystemRefName][role.tsrRoleRefName];
      externalSystems[role.tsrTargetSystemRefName][
        role.tsrRoleRefName
      ] = subRoles.map((subRole) => {
        if (subRole.tempID === role.tempID) {
          return {
            ...subRole,
            mode: "edit",
          };
        }
        return subRole;
      });
      this.setState({ externalSystems });
    };
  };

  resetExternalRefernceIDHandler = ({ role }) => {
    return () => {
      const { externalSystems } = this.state;

      const subRoles =
        externalSystems[role.tsrTargetSystemRefName][role.tsrRoleRefName];
      externalSystems[role.tsrTargetSystemRefName][
        role.tsrRoleRefName
      ] = subRoles.map((subRole) => {
        if (subRole.tempID === role.tempID) {
          return {
            ...subRole,
            mode: "read",
            tsrExternalId: subRole.originalValue,
          };
        }
        return subRole;
      });
      this.setState({ externalSystems });
    };
  };

  saveExternalReferenceIDHandler = ({ role }) => {
    return () => {
      const { externalSystems } = this.state;
      const subRoles =
        externalSystems[role.tsrTargetSystemRefName][role.tsrRoleRefName];
      externalSystems[role.tsrTargetSystemRefName][
        role.tsrRoleRefName
      ] = subRoles.map((subRole) => {
        if (subRole.tempID === role.tempID) {
          return {
            ...subRole,
            mode: "read",
            originalValue: subRole.tsrId,
          };
        }
        return subRole;
      });
      this.setState({ externalSystems });
    };
  };

  getExternalSystemRoles = () => {
    const { externalSystems } = this.state;
    if (!externalSystems) return;
    return Object.keys(externalSystems).map(
      (tsrTargetSystemRefName): ReactNode => {
        return (
          <Col key={tsrTargetSystemRefName} span={12}>
            <label>{tsrTargetSystemRefName}</label>
            <div className="external-system">
              <Row gutter={8}>
                {Object.keys(externalSystems[tsrTargetSystemRefName]).map(
                  (subRoleKey, index) => {
                    // should list sub role name and add functionality

                    const subRoleList =
                      externalSystems[tsrTargetSystemRefName][subRoleKey];

                    const baseKey = `${
                      subRoleList[0].pseudoRole
                    }__${tsrTargetSystemRefName}__${subRoleKey}`;
                    return (
                      <React.Fragment key={subRoleKey}>
                        {/* {index%3 === 0 && (<Row key={subRoleKey}>)} */}
                        <Col key={subRoleKey} span={12}>
                          <Form.Item
                            // required
                            {...formItemLayout}
                            // validateStatus={
                            //   this.state.businessPartnerNameOneError ? "error" : ""
                            // }
                            label={
                              <span>
                                {subRoleKey}
                                {this.state.modifyRoleManually && (
                                  <Button
                                    className="add-interface-toggler"
                                    onClick={this.toggleAddReferenceID(baseKey)}
                                    size="small"
                                    shape="circle"
                                    icon="plus"
                                  />
                                )}
                              </span>
                            }
                            // hasFeedback
                            // validateStatus="success"
                            help={
                              this.state.businessPartnerNameOneError
                                ? "This is a required field"
                                : ""
                            }
                          >
                            <div
                              className="add-reference-id"
                              style={{
                                display:
                                  this.state[`${baseKey}__add`] === true
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <Input
                                value={
                                  this.state[`${baseKey}__newReferenceID`] || ""
                                }
                                size="small"
                                onChange={this.externalRefernceChangeHandler({
                                  role: subRoleList[0],
                                  baseKey,
                                  newRole: true,
                                })}
                                addonAfter={
                                  <Button
                                    size="small"
                                    onClick={this.addExternalReferenceIDHandler(
                                      {
                                        role: subRoleList[0],
                                        baseKey,
                                      }
                                    )}
                                  >
                                    Add
                                  </Button>
                                }
                              />
                            </div>
                            <div className="external-reference-ids">
                              {subRoleList
                                .filter((item) => item.valid)
                                .map((item) => {
                                  const baseKey = `${item.pseudoRole}__${
                                    item.tsrTargetSystemRefName
                                  }__${item.tsrRoleRefName}`;
                                  return (
                                    <div
                                      className="external-reference-id__item"
                                      key={item.tempID}
                                    >
                                      {item.mode === "edit" ? (
                                        <>
                                          <Input
                                            value={item.tsrExternalId}
                                            size="small"
                                            onChange={this.externalRefernceChangeHandler(
                                              {
                                                role: item,
                                                baseKey,
                                                newRole: false,
                                              }
                                            )}
                                            className="edit-mode"
                                            addonAfter={
                                              <>
                                                <Button
                                                  size="small"
                                                  onClick={this.resetExternalRefernceIDHandler(
                                                    { role: item }
                                                  )}
                                                >
                                                  <Icon type="rollback" />
                                                </Button>
                                                <Button
                                                  size="small"
                                                  onClick={this.saveExternalReferenceIDHandler(
                                                    { role: item }
                                                  )}
                                                >
                                                  <Icon type="save" />
                                                </Button>
                                              </>
                                            }
                                          />
                                        </>
                                      ) : (
                                        <Input
                                          value={item.tsrExternalId}
                                          size="small"
                                          readOnly
                                          className="readonly-mode"
                                          addonAfter={
                                            this.state.modifyRoleManually && (
                                              <>
                                                <Button
                                                  size="small"
                                                  onClick={this.toggleEditExternalRferenceIDHandler(
                                                    { role: item }
                                                  )}
                                                >
                                                  <Icon type="edit" />
                                                </Button>
                                                <Button
                                                  size="small"
                                                  onClick={this.deleteExternalReferenceIDHandler(
                                                    { role: item }
                                                  )}
                                                >
                                                  <Icon type="delete" />
                                                </Button>
                                              </>
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                            </div>
                          </Form.Item>
                        </Col>
                        {/* {index%3 === 0 && (</Row>)} */}
                      </React.Fragment>
                    );
                  }
                )}
              </Row>
            </div>
          </Col>
        );
      }
    );
  };

  toggleRoleEdit = (modifyRoleManually) => {
    this.setState({ modifyRoleManually });
  };

  checkStateProvinceRequired = () => {
    const { countries } = this.props;
    return this.state.countryReference
      ? countries &&
          countries.find(
            (country) => country.coId === this.state.countryReference
          ).coSPCheck
      : false;
  };

  handleIsIBAN = (e) => {
    this.setState({ isIBAN: e.target.checked });
  };

  togglePoBoxCityModal = () => {
    this.setState({
      poBoxCityModalVisibility: !this.state.poBoxCityModalVisibility,
    });
  };

  copyAddresstoPOBox = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      poBoxCity: this.state.city,
      poBoxStateProvinceReference: this.state.stateProvinceReference,
      poBoxZipCode: this.state.postalCode,
    });
  };

  render() {
    const {
      countries,
      currencyRefs,
      duplicateBPs,
      stateProvinces,
      banks,
      userInfo,
      selectedBP,
      match,
      cities,
      postalCodes,
      bicSwifts,

      bpTypes,
      msalContext,
    } = this.props;
    const isAuthenticated = msalContext.accounts.length > 0;
    let roles: any[] = [];
    if (isAuthenticated) {
      roles = msalContext.accounts[0].idTokenClaims.roles || [];
    }

    // roles,
    const {
      mode,
      duplicateBPModalVisibility,
      countryReference,
      activePanels,
      rejectBPModalVisibility,
      stateProvinceReference,
      poBoxStateProvinceReference,
    } = this.state;

    const selectedCountry =
      countryReference && countries
        ? countries.find((item) => item.coId === this.state.countryReference)
        : null;
    const selectedProvince =
      stateProvinceReference && stateProvinces
        ? stateProvinces.find((item) => item.spId === stateProvinceReference)
        : null;
    const selectedPoBoxProvince =
      poBoxStateProvinceReference && stateProvinces
        ? stateProvinces.find(
            (item) => item.spId === poBoxStateProvinceReference
          )
        : null;
    const hasSupplierRole = this.checkHasSupplierRole();
    let statusColor = "gray";
    if (selectedBP) {
      switch (selectedBP.bpStatus) {
        case 4: {
          statusColor = "blue";
          break;
        }
        case 5: {
          statusColor = "red";
          break;
        }
        case 6: {
          statusColor = "green";
          break;
        }
        case 7: {
          statusColor = "orange";
          break;
        }
        case 8: {
          statusColor = "gray";
          break;
        }
        default: {
          statusColor = "gray";
          break;
        }
      }
    }

    const isDataSteward =
      roles && roles.indexOf("DataSteward") > -1;

    const isVATCountry =
      countries && countryReference
        ? countries.find((item) => item.coId === countryReference).coVATCheck
        : false;
    const isStateProvinceMandatory = this.checkStateProvinceRequired();

    // cities are filtered based on state province reference if present
    let stateCities = this.state.stateProvinceReference
      ? this.props.cities
        ? this.props.cities.filter(
            (item) =>
              item.ciStateProvinceRef &&
              item.ciStateProvinceRef === this.state.stateProvinceReference
          )
        : []
      : this.props.cities
      ? this.props.cities
      : [];

    // pobox cities are filtered based on po boxstate province reference if present
    let poBoxStateCities = this.state.poBoxStateProvinceReference
      ? this.props.cities
        ? this.props.cities.filter(
            (item) =>
              item.ciStateProvinceRef &&
              item.ciStateProvinceRef === this.state.poBoxStateProvinceReference
          )
        : []
      : this.props.cities
      ? this.props.cities
      : [];

    const isRoleManuallySet =
      selectedBP &&
      selectedBP.targetSystemRoles.length > 0 &&
      selectedBP.targetSystemRoles.filter((item) => item.tsrManual).length > 0;

    return (
      <div className="business-partner-wrap">
        {mode === "create" && (
          <h2 className="page-title">
            Create New <span>Business Partner</span>
          </h2>
        )}
        {mode === "update" && (
          <h2>
            Update <span>BP</span>
          </h2>
        )}
        <div className="business-partner-form-wrap">
          <Form className="ant-advanced-search-form">
            <h3 className="custom-padding">
              Basic Information{" "}
              {this.state.bpId ? ` of ${this.state.bpId}` : ""}
              {selectedBP && (
                <span style={{ float: "right", fontWeight: "normal" }}>
                  Status{" "}
                  <Tag color={statusColor}> {selectedBP.bpStatusName}</Tag>
                  {selectedBP.bpStatusName.toLowerCase() === "changed" ? (
                    <Tag> {selectedBP.bpActionName} </Tag>
                  ) : (
                    ""
                  )}
                </span>
              )}
            </h3>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  {...formItemLayout}
                  required
                  validateStatus={
                    this.state.businessPartnerNameOneError ? "error" : ""
                  }
                  label="BP Name One"
                  // hasFeedback
                  // validateStatus="success"
                  help={
                    this.state.businessPartnerNameOneError
                      ? "This is a required field"
                      : ""
                  }
                >
                  <Input.Search
                    autoComplete="random"
                    value={this.state.businessPartnerNameOne}
                    onChange={(e) =>
                      this.formChangeHandler(
                        e.target.value,
                        "businessPartnerNameOne",
                        "businessPartnerNameOneError"
                      )
                    }
                    onSearch={this.onSearch}
                    onKeyDown={this.checkDuplicateOf}
                    maxLength={35}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  {...formItemLayout}
                  label="BP Name Two"
                  validateStatus={
                    this.state.businessPartnerNameTwoError ? "error" : ""
                  }
                  help={
                    this.state.businessPartnerNameTwoError
                      ? "Length of the field has exceeded."
                      : ""
                  }
                >
                  <Input
                    autoComplete="random"
                    value={this.state.businessPartnerNameTwo}
                    onChange={(e) =>
                      this.formChangeHandler(
                        e.target.value,
                        "businessPartnerNameTwo",
                        "businessPartnerNameTwoError"
                      )
                    }
                    maxLength={30}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item {...formItemLayout} label="Search Name">
                  <Input
                    autoComplete="random"
                    value={this.state.searchName}
                    onChange={(e) =>
                      this.formChangeHandler(e.target.value, "searchName", "")
                    }
                    maxLength={15}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  {...formItemLayout}
                  label="Telephone Number"
                  validateStatus={
                    this.state.telephoneNumberError ? "error" : ""
                  }
                  help={
                    this.state.telephoneNumberError
                      ? "Invalid telephone number"
                      : ""
                  }
                >
                  <Input
                    maxLength={20}
                    value={
                      this.state.telephoneNumber &&
                      this.state.telephoneNumber.toString()
                    }
                    name="telephone-number"
                    onChange={(e) =>
                      this.formChangeHandler(
                        e.target.value,
                        "telephoneNumber",
                        "telephoneNumberError"
                      )
                    }
                    autoComplete="random"
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  {...formItemLayout}
                  label="E-mail"
                  validateStatus={this.state.emailError ? "error" : ""}
                  help={this.state.emailError ? "Invalid email" : ""}
                >
                  <Input
                    autoComplete="random"
                    value={this.state.email}
                    onChange={(e) => {
                      this.formChangeHandler(
                        e.target.value,
                        "email",
                        "emailError"
                      );
                    }}
                    maxLength={49}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  {...formItemLayout}
                  label="Website"
                  validateStatus={this.state.websiteError ? "error" : ""}
                  help={this.state.websiteError ? "Invalid website url" : ""}
                >
                  <Input
                    autoComplete="random"
                    value={this.state.website}
                    onChange={(e) =>
                      this.formChangeHandler(
                        e.target.value,
                        "website",
                        "websiteError"
                      )
                    }
                    maxLength={49}
                  />
                </Form.Item>
              </Col>

              {((selectedBP && selectedBP.bpStatus < 6) ||
                this.state.mode === "create") && (
                <Col span={24}>
                  <Form.Item
                    {...formItemLayout}
                    label="BP Role"
                    // required
                    validateStatus={this.state.selectedRoleError ? "error" : ""}
                    help={
                      this.state.selectedRoleError
                        ? "One role must be selected."
                        : ""
                    }
                  >
                    <Radio.Group
                      onChange={this.onRoleChange}
                      value={this.state.selectedRole}
                    >
                      {bpTypes &&
                        bpTypes.map((item) => {
                          return (
                            <Radio
                              value={item.coId}
                              key={item.coId}
                              checked={item.coId === this.state.selectedRole}
                            >
                              {item.coValue}
                            </Radio>
                          );
                        })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              )}
              {this.state.selectedRole && (
                <Col span={24}>
                  <Form.Item
                    {...formItemLayout}
                    label={
                      selectedBP &&
                      selectedBP.targetSystemRoles.length > 0 &&
                      !selectedBP.targetSystemRoles.some(
                        (role) => !role.tsrSynchronised
                      ) ? (
                        <>
                          <span>Target System Role </span>
                          <Tag color="green">Synced</Tag>
                          {isRoleManuallySet && (
                            <Tag color="purple">Manually Edited</Tag>
                          )}
                        </>
                      ) : (
                        <>
                          <span>Target System Role </span>
                          <Tag color="gray"> Not synced yet</Tag>
                          {isRoleManuallySet && (
                            <Tag color="purple">Manually Edited</Tag>
                          )}
                        </>
                      )
                    }
                  >
                    {isDataSteward && (
                      <div className="manual-role-toggler">
                        <span
                          onClick={() =>
                            this.toggleRoleEdit(!this.state.modifyRoleManually)
                          }
                        >{`Edit roles manually `}</span>
                        <Switch
                          disabled={!this.state.selectedRole}
                          size="small"
                          checked={this.state.modifyRoleManually}
                          onChange={this.toggleRoleEdit}
                        />
                      </div>
                    )}
                    <Row gutter={12}>{this.getExternalSystemRoles()}</Row>
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Collapse
              bordered={false}
              activeKey={activePanels}
              onChange={this.collaspPanel}
              expandIcon={({ isActive }) => (
                <Icon type="caret-right" rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel key="1" header="Business Partner Address">
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="Country"
                      required
                      validateStatus={
                        this.state.countryReferenceError ? "error" : ""
                      }
                      help={
                        this.state.countryReferenceError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        value={this.state.countryReference || undefined}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value, option) =>
                          this.formChangeHandler(
                            value,
                            "countryReference",
                            "countryReferenceError",
                            { data: option && option.props }
                          )
                        }
                        placeholder="Select a country"
                      >
                        {countries &&
                          countries.map(function(item) {
                            return (
                              <Option
                                value={item.coId}
                                key={item.coId}
                                data-sepa-country={item.coSepaCheck}
                              >
                                {item.coDescription}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="City"
                      className="city-postalcode-style"
                      required
                      validateStatus={this.state.cityError ? "error" : ""}
                      help={
                        this.state.cityError ? "This is a required field" : ""
                      }
                    >
                      <Select
                        allowClear
                        style={{ width: "calc(100% - 40px)" }}
                        value={this.state.city || undefined}
                        onChange={(value, option) =>
                          this.formChangeHandler(value, "city", "cityError", {
                            data: option ? option.props : {},
                          })
                        }
                        disabled={!!this.state.countryReference === false}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Select a city"
                      >
                        {stateCities.map((item) => (
                          <Option
                            key={item.ciId}
                            value={item.ciId}
                            data-spid={item.ciStateProvinceRef || null}
                          >
                            {item.ciCity}
                          </Option>
                        ))}
                      </Select>

                      <Button
                        icon={`${this.state.city ? "edit" : "plus"}`}
                        onClick={this.toggleCityModal}
                        disabled={!!this.state.countryReference === false}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="State Province"
                      required={isStateProvinceMandatory}
                      validateStatus={
                        this.state.stateProvinceReferenceError ? "error" : ""
                      }
                      help={
                        this.state.stateProvinceReferenceError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        style={{ width: "100%" }}
                        value={this.state.stateProvinceReference || undefined}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value) =>
                          this.formChangeHandler(
                            value,
                            "stateProvinceReference",
                            "stateProvinceReferenceError"
                          )
                        }
                        disabled={!!this.state.countryReference === false}
                        placeholder="Select a state province"
                      >
                        {stateProvinces &&
                          stateProvinces.map((item) => {
                            return (
                              <Option value={item.spId} key={item.spId}>
                                {item.spDescription}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="ZIP Code/Postal Code"
                      className="city-postalcode-style"
                      required
                      validateStatus={this.state.postalCodeError ? "error" : ""}
                      help={
                        this.state.postalCodeError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        style={{ width: "calc(100% - 40px)" }}
                        value={this.state.postalCode || undefined}
                        onChange={(value: number) =>
                          this.formChangeHandler(
                            value,
                            "postalCode",
                            "postalCodeError"
                          )
                        }
                        disabled={!!this.state.countryReference === false}
                        showSearch
                        placeholder="Select Postal Code"
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {/* <Option value="">Select Postal Code</Option> */}
                        {postalCodes &&
                          postalCodes.map((item) => (
                            <Option key={item.pcId} value={item.pcId}>
                              {item.pcPostalcode}
                            </Option>
                          ))}
                      </Select>
                      <Button
                        onClick={this.togglePostalCodeModal}
                        icon={`${this.state.postalCode ? "edit" : "plus"}`}
                        disabled={!!this.state.countryReference === false}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="Street 1"
                      required
                      validateStatus={this.state.streetOneError ? "error" : ""}
                      help={
                        this.state.streetOneError
                          ? this.state.streetOne.length > 30
                            ? "Length of the field has exceeded."
                            : "This is a required field"
                          : ""
                      }
                    >
                      <Input
                        autoComplete="random"
                        value={this.state.streetOne}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "streetOne",
                            "streetOneError"
                          )
                        }
                        maxLength={30}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item {...formItemLayout} label="House Number">
                      <Input
                        autoComplete="random"
                        value={this.state.houseNumber}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "houseNumber",
                            ""
                          )
                        }
                        maxLength={10}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
              <Panel
                key="2"
                header="Post Office Box"
                extra={
                  <div>
                    <Button
                      size="small"
                      type="ghost"
                      icon="copy"
                      onClick={this.copyAddresstoPOBox}
                      disabled={!this.state.countryReference}
                      title="Copy address from Business Partner Address"
                    >
                      Copy Address
                    </Button>
                  </div>
                }
              >
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item {...formItemLayout} label="Post Office Box">
                      <Input
                        autoComplete="random"
                        value={this.state.postOfficeBox}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "postOfficeBox",
                            ""
                          )
                        }
                        maxLength={10}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="Country"
                      required={!!this.state.postOfficeBox}
                      validateStatus={
                        !!this.state.postOfficeBox &&
                        this.state.countryReferenceError
                          ? "error"
                          : ""
                      }
                      help={
                        !!this.state.postOfficeBox &&
                        this.state.countryReferenceError
                          ? "Please select country in address field."
                          : ""
                      }
                    >
                      <Select
                        disabled
                        value={this.state.poBoxCountryReference || undefined}
                        placeholder="Select a Country"
                      >
                        {countries &&
                          countries.map((item) => (
                            <Option
                              value={item.coId}
                              key={item.coCountry}
                              data-country-code={item.coCountry}
                            >
                              {item.coDescription}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="PO Box City"
                      className="city-postalcode-style"
                      required={!!this.state.postOfficeBox}
                      validateStatus={
                        !!this.state.postOfficeBox && this.state.poBoxCityError
                          ? "error"
                          : ""
                      }
                      help={
                        !!this.state.postOfficeBox && this.state.poBoxCityError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        style={{ width: "calc(100% - 40px)" }}
                        value={this.state.poBoxCity || undefined}
                        disabled={!!this.state.poBoxCountryReference === false}
                        onChange={(value: number, option) =>
                          this.formChangeHandler(
                            value,
                            "poBoxCity",
                            "poBoxCityError",
                            {
                              data: option ? option.props : {},
                            }
                          )
                        }
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Select a PO Box City"
                      >
                        {poBoxStateCities.map((item) => (
                          <Option
                            key={item.ciId}
                            value={item.ciId}
                            data-spid={item.ciStateProvinceRef || null}
                          >
                            {item.ciCity}
                          </Option>
                        ))}
                      </Select>
                      <Button
                        icon={`${this.state.poBoxCity ? "edit" : "plus"}`}
                        onClick={this.togglePoBoxCityModal}
                        disabled={!!this.state.countryReference === false}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="PO Box State Province"
                      required={
                        !!this.state.postOfficeBox && isStateProvinceMandatory
                      }
                      validateStatus={
                        !!this.state.postOfficeBox &&
                        this.state.poBoxStateProvinceReferenceError
                          ? "error"
                          : ""
                      }
                      help={
                        !!this.state.postOfficeBox &&
                        this.state.poBoxStateProvinceReferenceError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        style={{ width: "100%" }}
                        value={
                          this.state.poBoxStateProvinceReference || undefined
                        }
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value) =>
                          this.formChangeHandler(
                            value,
                            "poBoxStateProvinceReference",
                            "poBoxStateProvinceReferenceError"
                          )
                        }
                        disabled={!!this.state.poBoxCountryReference === false}
                        placeholder="Select a state province"
                      >
                        {stateProvinces &&
                          stateProvinces.map((item) => {
                            return (
                              <Option value={item.spId} key={item.spId}>
                                {item.spDescription}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="PO Box Zip Code"
                      className="city-postalcode-style"
                      required={!!this.state.postOfficeBox}
                      validateStatus={
                        !!this.state.postOfficeBox &&
                        this.state.poBoxZipCodeError
                          ? "error"
                          : ""
                      }
                      help={
                        !!this.state.postOfficeBox &&
                        this.state.poBoxZipCodeError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        disabled={!!this.state.poBoxCountryReference === false}
                        style={{ width: "calc(100% - 40px)" }}
                        value={this.state.poBoxZipCode || undefined}
                        placeholder="Select PO Box Zip Code"
                        onChange={(value: number) =>
                          this.formChangeHandler(
                            value,
                            "poBoxZipCode",
                            "poBoxZipCodeError"
                          )
                        }
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {/* <Option value="">Select Postal Code</Option> */}
                        {postalCodes &&
                          postalCodes.map((item) => (
                            <Option key={item.pcId} value={item.pcId}>
                              {item.pcPostalcode}
                            </Option>
                          ))}
                      </Select>
                      <Button
                        onClick={this.togglePoBoxPostalCodeModal}
                        icon={`${this.state.poBoxZipCode ? "edit" : "plus"}`}
                        disabled={!!this.state.countryReference === false}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
              <Panel key="3" header="Bank Details">
                <Row gutter={24}>
                  <Col span={1} style={{ paddingRight: 0 }}>
                    <Form.Item {...formItemLayout} label="IBAN">
                      <Checkbox
                        id="isIBAN"
                        onChange={this.handleIsIBAN}
                        defaultChecked
                        checked={this.state.isIBAN}
                        disabled={this.state.sepaCountry}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      {...formItemLayout}
                      label="IBAN Number/Bank Account Number"
                      required={hasSupplierRole || !!this.state.bankCountry}
                      validateStatus={
                        (hasSupplierRole &&
                          this.state.bankAccountNumberError) ||
                        this.state.bankAccountNumberError
                          ? "error"
                          : this.state.bankIBANError
                          ? "error"
                          : ""
                      }
                      help={
                        hasSupplierRole && this.state.bankAccountNumberError
                          ? "Supplier roles requires Bank Account"
                          : this.state.bankAccountNumberError
                          ? "This is required field"
                          : this.state.bankIBANError
                          ? "Invalid IBAN"
                          : ""
                      }
                    >
                      <Input
                        autoComplete="random"
                        placeholder="IBAN Number/Bank Account Number"
                        value={this.state.bankAccountNumber}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "bankAccountNumber",
                            "bankAccountNumberError"
                          )
                        }
                        maxLength={34}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="Country"
                      required={
                        (isDataSteward && hasSupplierRole) ||
                        this.state.bankAccountNumber !== ""
                      }
                      validateStatus={
                        this.state.bankCountryError ? "error" : ""
                      }
                      help={
                        this.state.bankCountryError
                          ? this.state.bankCountry &&
                            this.state.bankAccountNumber
                              .substring(0, 2)
                              .toUpperCase() !==
                              (
                                this.props.countries.find(
                                  (country) =>
                                    country.coId === this.state.bankCountry
                                ) || { coCountry: "" }
                              ).coCountry
                            ? "Bank Country does not match"
                            : "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        value={this.state.bankCountry || undefined}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value, option) =>
                          this.formChangeHandler(
                            value,
                            "bankCountry",
                            "bankCountryError",
                            { data: option && option.props }
                          )
                        }
                        placeholder="Select a Country"
                      >
                        {countries &&
                          countries.map(function(item) {
                            return (
                              <Option
                                value={item.coId}
                                key={item.coCountry}
                                data-country-code={item.coCountry}
                              >
                                {item.coDescription}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      {...formItemLayout}
                      label="BIC/SWIFT"
                      required={
                        (isDataSteward && hasSupplierRole) ||
                        this.state.bankAccountNumber !== ""
                      }
                      validateStatus={this.state.bicSwiftError ? "error" : ""}
                      help={
                        this.state.bicSwiftError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: "100%" }}
                        value={this.state.bicSwift || undefined}
                        onChange={(value, option) =>
                          this.formChangeHandler(
                            value,
                            "bicSwift",
                            "bicSwiftError",
                            { data: option && option.props }
                          )
                        }
                        placeholder="Select a Bic/Swift"
                      >
                        {bicSwifts &&
                          bicSwifts.map((item) => (
                            <Option
                              key={item.bicSwiftCode}
                              value={item.bicSwiftCode}
                              data-bank={item.bankName}
                            >
                              {item.bicSwiftCode}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item {...formItemLayout} label="Bank Name">
                      <Input
                        autoComplete="random"
                        placeholder="Bank Name"
                        value={
                          this.props.bankBranch &&
                          this.props.bankBranch.bankName
                        }
                        readOnly
                      />
                      {this.props.bankBranch &&
                        this.props.bankBranch.bankName === "" &&
                        this.props.bankBranch.bankMessage}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
              <Panel key="4" header="Additional Business Information">
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="VIES Country"
                      required={this.state.taxNumber.trim() !== ""}
                      validateStatus={
                        this.state.viesCountryError ? "error" : ""
                      }
                      help={
                        this.state.viesCountryError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        value={this.state.viesCountry || undefined}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value: number, option) =>
                          this.formChangeHandler(
                            value,
                            "viesCountry",
                            "viesCountryError"
                          )
                        }
                        placeholder="Select a country"
                      >
                        {countries &&
                          countries
                            .filter((item) => item.coEUCheck)
                            .map((item) => {
                              return (
                                <Option value={item.coId} key={item.coId}>
                                  {item.coDescription}
                                </Option>
                              );
                            })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="VIES Number"
                      required={
                        this.state.countryReference &&
                        (this.state.isEUCountry
                          ? this.state.nationalVATNumber.trim() === ""
                          : this.state.nationalVATNumber.trim() === "" &&
                            this.state.intTaxNumber.trim() === "")
                      }
                      validateStatus={
                        this.state.taxNumberError ||
                        this.state.euTaxError ||
                        this.state.nonEUTaxError
                          ? "error"
                          : ""
                      }
                      help={
                        this.state.taxNumberError
                          ? "Invalid Tax Number"
                          : this.state.euTaxError
                          ? euTaxErrMessage
                          : this.state.nonEUTaxError
                          ? nonEUTaxErrMessage
                          : ""
                      }
                    >
                      <Input
                        className="vies-number"
                        addonBefore={
                          this.state.viesCountryCode
                            ? this.state.viesCountryCode
                            : null
                        }
                        autoComplete="random"
                        value={this.state.taxNumber}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "taxNumber",
                            "taxNumberError"
                          )
                        }
                        maxLength={25}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="Int. Tax(Non-EU Countries) Country"
                      required={this.state.intTaxNumber.trim() !== ""}
                      validateStatus={
                        this.state.intTaxCountryError ? "error" : ""
                      }
                      help={
                        this.state.intTaxCountryError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        value={this.state.intTaxCountry || undefined}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value, option) =>
                          this.formChangeHandler(
                            value,
                            "intTaxCountry",
                            "intTaxCountryError",
                            { data: option && option.props }
                          )
                        }
                        placeholder="Select a country"
                        disabled={
                          this.state.countryReference && this.state.isEUCountry
                        }
                      >
                        {countries &&
                          countries
                            .filter((item) => !item.coEUCheck)
                            .map(function(item) {
                              return (
                                <Option
                                  value={item.coId}
                                  key={item.coId}
                                  data-sepa-country={item.coSepaCheck}
                                >
                                  {item.coDescription}
                                </Option>
                              );
                            })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="International Tax(Non EU Countries)"
                      required={
                        this.state.countryReference &&
                        (!this.state.isEUCountry
                          ? this.state.taxNumber.trim() === "" &&
                            this.state.nationalVATNumber.trim() === ""
                          : false)
                      }
                      validateStatus={this.state.nonEUTaxError ? "error" : ""}
                      help={this.state.nonEUTaxError ? nonEUTaxErrMessage : ""}
                    >
                      <Input
                        autoComplete="random"
                        value={this.state.intTaxNumber}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "intTaxNumber",
                            "intTaxNumberError"
                          )
                        }
                        maxLength={49}
                        disabled={
                          this.state.countryReference && this.state.isEUCountry
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="Local Tax/Fiscal ID Country"
                      required={this.state.nationalVATNumber.trim() !== ""}
                      validateStatus={
                        this.state.localTaxCountryError ? "error" : ""
                      }
                      help={
                        this.state.localTaxCountryError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        value={this.state.localTaxCountry || undefined}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value, option) =>
                          this.formChangeHandler(
                            value,
                            "localTaxCountry",
                            "localTaxCountryError",
                            { data: option && option.props }
                          )
                        }
                        placeholder="Select a country"
                      >
                        {countries &&
                          countries.map(function(item) {
                            return (
                              <Option
                                value={item.coId}
                                key={item.coId}
                                data-sepa-country={item.coSepaCheck}
                              >
                                {item.coDescription}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...formItemLayout}
                      label="Local Tax/Fiscal ID"
                      required={
                        this.state.countryReference &&
                        (this.state.isEUCountry
                          ? this.state.taxNumber.trim() === ""
                          : this.state.taxNumber.trim() === "" &&
                            this.state.intTaxNumber.trim() === "")
                      }
                      validateStatus={
                        this.state.euTaxError || this.state.nonEUTaxError
                          ? "error"
                          : ""
                      }
                      help={
                        this.state.euTaxError
                          ? euTaxErrMessage
                          : this.state.nonEUTaxError
                          ? nonEUTaxErrMessage
                          : ""
                      }
                    >
                      <Input
                        autoComplete="random"
                        value={this.state.nationalVATNumber}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "nationalVATNumber",
                            ""
                          )
                        }
                        maxLength={49}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  {hasSupplierRole && (
                    <Col span={6}>
                      <Form.Item
                        {...formItemLayout}
                        label="Expected Yearly Turnover"
                        required
                        validateStatus={
                          this.state.yearlyTurnoverError ? "error" : ""
                        }
                        help={
                          this.state.yearlyTurnoverError
                            ? "This is a required field"
                            : ""
                        }
                      >
                        <Input
                          autoComplete="random"
                          value={this.state.yearlyTurnover}
                          onChange={(e) =>
                            this.formChangeHandler(
                              e.target.value,
                              "yearlyTurnover",
                              "yearlyTurnoverError"
                            )
                          }
                          maxLength={49}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={6}>
                    <Form.Item {...formItemLayout} label="Chamber of Commerce">
                      <Input
                        autoComplete="random"
                        value={this.state.chamberOfCommerce}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "chamberOfCommerce",
                            ""
                          )
                        }
                        maxLength={20}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item {...formItemLayout} label="DUNS number">
                      <Input
                        autoComplete="random"
                        value={this.state.dunsNumber}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "dunsNumber",
                            ""
                          )
                        }
                        maxLength={15}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      {...formItemLayout}
                      label="Currency"
                      required
                      validateStatus={
                        this.state.currencyReferrenceError ? "error" : ""
                      }
                      help={
                        this.state.currencyReferrenceError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Select
                        allowClear
                        value={this.state.currencyReferrence || undefined}
                        // defaultValue={this.state.currencyReferrence}
                        placeholder="Select a currency"
                        onChange={(value) =>
                          this.formChangeHandler(
                            value,
                            "currencyReferrence",
                            "currencyReferrenceError"
                          )
                        }
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children &&
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {currencyRefs &&
                          currencyRefs.map(function(item) {
                            return (
                              <Option value={item.cuId} key={item.cuId}>
                                {item.cuCurrency}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>

                  {hasSupplierRole && (
                    <Col span={4}>
                      <Form.Item
                        {...formItemLayout}
                        label="Payment Terms"
                        required
                        validateStatus={
                          this.state.paymentTermsError ? "error" : ""
                        }
                        help={
                          this.state.paymentTermsError
                            ? "This is a required field"
                            : ""
                        }
                      >
                        <Input
                          autoComplete="random"
                          value={this.state.paymentTerms}
                          onChange={(e) =>
                            this.formChangeHandler(
                              e.target.value,
                              "paymentTerms",
                              "paymentTermsError"
                            )
                          }
                          maxLength={49}
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      {...formItemLayout}
                      label="Relevant Plant(s) for BP"
                      required
                      validateStatus={
                        this.state.relevantPlantsError ? "error" : ""
                      }
                      help={
                        this.state.relevantPlantsError
                          ? "This is a required field"
                          : ""
                      }
                    >
                      <Input.TextArea
                        autoComplete="random"
                        value={this.state.relevantPlants}
                        autosize={{ minRows: 4, maxRows: 6 }}
                        onChange={(e) =>
                          this.formChangeHandler(
                            e.target.value,
                            "relevantPlants",
                            "relevantPlantsError"
                          )
                        }
                        maxLength={128}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item {...formItemLayout} label="Comments">
                      <Input.TextArea
                        autoComplete="random"
                        value={this.state.comments}
                        autosize={{ minRows: 4, maxRows: 6 }}
                        onChange={(e) =>
                          this.formChangeHandler(e.target.value, "comments", "")
                        }
                        maxLength={1024}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
            {selectedBP &&
              selectedBP.bpRejectComment.length > 0 &&
              this.state.bpId &&
              selectedBP.bpStatus === 5 && (
                <div
                  className="reject-history"
                  style={{ marginTop: 5, borderTop: "1px solid #eaeaf4" }}
                >
                  <Collapse
                    bordered={false}
                    expandIcon={({ isActive }) => (
                      <Icon type="caret-right" rotate={isActive ? 90 : 0} />
                    )}
                  >
                    <Panel
                      showArrow={true}
                      header={`Reject History (${
                        selectedBP.bpRejectComment.length
                      })`}
                      key="1"
                    >
                      <table>
                        <colgroup>
                          <col width="200" />
                          <col width="200" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>Rejected Date</th>
                            <th>Rejected By</th>
                            <th>Remark</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedBP.bpRejectComment
                            // .sort((a, b) => new Date(a) < new Date(b))
                            .map((item) => {
                              return (
                                <tr
                                  className="reject-hisotry___item"
                                  key={item.brcId}
                                >
                                  <td>
                                    {moment(new Date(item.brcDate)).format(
                                      "MM-DD-YYYY"
                                    )}
                                  </td>
                                  <td>{item.brcPerson}</td>
                                  <td> {item.brcComment}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </Panel>
                  </Collapse>
                </div>
              )}
            {!isDataSteward &&
            selectedBP &&
            selectedBP.bpAction === 10 ? null : (
              <Row gutter={24} className="border-top">
                <Col span={24} style={{ textAlign: "right" }}>
                  {/* <Button style={{ marginLeft: 8 }}>Cancel</Button> */}
                  {mode === "create" && (
                    <Button
                      type="primary"
                      style={{ marginLeft: 8 }}
                      onClick={this.createBusinessPartner}
                      icon="plus"
                    >
                      Create
                    </Button>
                  )}
                  {/* if user is data steward and bp status is not rejected */}
                  {mode === "update" &&
                    selectedBP &&
                    selectedBP.bpStatus !== 8 &&
                    selectedBP.bpAction !== 11 && (
                      <Button
                        style={{ marginLeft: 8 }}
                        onClick={this.deleteBusinessPartner}
                        icon="delete"
                      >
                        Delete
                      </Button>
                    )}
                  {mode === "update" &&
                    isDataSteward &&
                    selectedBP &&
                    selectedBP.bpAction === 10 && (
                      <Button
                        style={{ marginLeft: 8 }}
                        onClick={this.rejectDelete}
                        icon="close"
                        type="primary"
                      >
                        Reject Delete
                      </Button>
                    )}
                  {mode === "update" &&
                    isDataSteward &&
                    selectedBP &&
                    selectedBP.bpAction === 11 && (
                      <Button
                        style={{ marginLeft: 8 }}
                        onClick={this.deleteBusinessPartner}
                        icon="delete"
                      >
                        Reject Approval
                      </Button>
                    )}
                  {roles.indexOf("DataSteward") > -1 &&
                    (selectedBP &&
                      selectedBP.bpStatus < 5 &&
                      mode === "update" && (
                        <Button
                          type="primary"
                          icon="close"
                          style={{ marginLeft: 8 }}
                          onClick={this.toggleRejectBPModal}
                        >
                          Reject
                        </Button>
                      ))}

                  {mode === "update" &&
                    selectedBP &&
                    selectedBP.bpAction !== 10 && (
                      // selectedBP.bpAction !== 11 &&
                      <Button
                        type="primary"
                        style={{ marginLeft: 8 }}
                        icon="save"
                        onClick={this.updateBusinessPartner}
                      >
                        Update
                      </Button>
                    )}
                  {selectedBP &&
                    roles.indexOf("DataSteward") > -1 &&
                    selectedBP.bpAction !== 10 &&
                    mode === "update" &&
                    [4, 7, 8].indexOf(selectedBP.bpStatus) > -1 && (
                      <Button
                        type="primary"
                        style={{ marginLeft: 8 }}
                        onClick={this.approveBusinessPartner}
                        icon="check"
                      >
                        Approve
                      </Button>
                    )}
                </Col>
              </Row>
            )}
          </Form>
        </div>
        {this.state.cityModalVisibility && (
          <City
            close={this.toggleCityModal}
            stateProvinces={this.props.stateProvinces}
            country={selectedCountry}
            createCity={this.props.createCity}
            province={selectedProvince}
            city={
              this.props.cities.find((item) => item.ciId === this.state.city) ||
              null
            }
            updateCity={this.props.updateCity}
            cities={this.props.cities}
            cityOf="address"
          />
        )}
        {this.state.poBoxCityModalVisibility && (
          <City
            close={this.togglePoBoxCityModal}
            stateProvinces={this.props.stateProvinces}
            country={selectedCountry}
            createCity={this.props.createCity}
            province={selectedPoBoxProvince}
            city={
              this.props.cities.find(
                (item) => item.ciId === this.state.poBoxCity
              ) || null
            }
            updateCity={this.props.updateCity}
            cities={this.props.cities}
            cityOf="pobox"
          />
        )}
        {this.state.postalCodeModalVisibility && (
          <PostalCode
            close={this.togglePostalCodeModal}
            country={selectedCountry}
            postalCode={
              this.props.postalCodes.find(
                (item) => item.pcId === this.state.postalCode
              ) || null
            }
            createPostalCode={this.props.createPostalCode}
            updatePostalCode={this.props.updatePostalCode}
            postalCodes={this.props.postalCodes}
            zipCodeOf="address"
          />
        )}
        {this.state.poBoxPostalCodeModalVisibility && (
          <PostalCode
            close={this.togglePoBoxPostalCodeModal}
            country={selectedCountry}
            postalCode={
              this.props.postalCodes.find(
                (item) => item.pcId === this.state.poBoxZipCode
              ) || null
            }
            createPostalCode={this.props.createPostalCode}
            updatePostalCode={this.props.updatePostalCode}
            postalCodes={this.props.postalCodes}
            zipCodeOf="pobox"
          />
        )}
        {duplicateBPModalVisibility && (
          <DuplicateBusinessPartners
            businessPartnerName={this.state.businessPartnerNameOne}
            duplicateBPs={duplicateBPs}
            close={this.toggleDuplicateBPModal}
            setSelectedBP={this.props.setSelectedBP}
            statuses={this.props.statuses}
            copyBP={this.copyBP}
            setModeToUpdate={this.setModeToUpdate}
            duplicateBPPagination={this.props.duplicateBPPagination}
            checkDubplicateOf={this.props.checkDubplicateOf}
          />
        )}
        {rejectBPModalVisibility && (
          <RejectBusinessPartner
            close={this.toggleRejectBPModal}
            rejectBusinessPartner={this.rejectBusinessPartner}
            businessPartner={this.props.selectedBP}
          />
        )}
      </div>
    );
  }
}
export default withMsal<any>(BusinessPartnerDetails);
